// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:33:06.621Z
// Property: Phoenix Apts (ID: 6767906449167045)
// Collections: 32 amenities, 4 floorplans (live), 36 photos, 71 POIs, 1 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449167045",
  "property_external_id": "48292",
  "property_zillow_url": "https://www.zillow.com/apartments/el-paso-tx/phoenix-apts./5XqvMm/",
  "property_apartments_url": "https://www.apartments.com/phoenix-apts-el-paso-tx/0legdp1/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Phoenix+Apartments/data=!4m2!3m1!1s0x0:0xbcb39aad38ba3ba1?sa=X&ved=2ahUKEwjj_KryiIOTAxV4kIkEHZwSMcsQ_BJ6BAg9EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "2476014928",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "phoenix-apts.",
  "property_name": "Phoenix Apts",
  "property_website_url": "https://www.caseusa.com/apartments/tx/el-paso/the-phoenix/",
  "property_domain": null,
  "property_address": "7401 Phoenix Avenue",
  "property_full_address": "7401 Phoenix Avenue, El Paso, TX, 79915",
  "property_address_1": "7401 Phoenix Avenue",
  "property_address_2": null,
  "property_address_city": "El Paso",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "79915",
  "property_address_country": "US",
  "property_address_county": "El Paso County",
  "property_neighborhood_address": "Mission Valley",
  "property_address_latitude": "31.7553",
  "property_address_longitude": "-106.3691",
  "property_email": "thephoenix@caseusa.com",
  "property_phone": "(915) 465-4537",
  "property_call_tracking_phone": "833-306-1517",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Phoenix Apts, your new El Paso home awaits! Choose from spacious one, two, or three-bedroom layouts adorned with modern amenities like a fitness center, pool, and pet-friendly spaces. Enjoy the convenience of on-site management, laundry facilities, and a vibrant clubhouse. Experience comfort and community—schedule your visit today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Welcome to Phoenix Apts in El Paso, TX!**\n\nDiscover your perfect sanctuary at Phoenix Apts, where comfort meets convenience in a vibrant community setting. Our spacious floor plans include inviting one, two, and three-bedroom options, thoughtfully designed to cater to your unique lifestyle. Each apartment boasts essential amenities like a fully-equipped kitchen with modern appliances, walk-in closets, and high-speed internet access, ensuring you feel right at home.\n\nAt Phoenix Apts, we prioritize your well-being and convenience with an impressive array of community amenities. Enjoy a refreshing dip in our sparkling pool, challenge friends on the basketball court, or unwind in the cozy clubhouse. Our fitness center is perfect for those looking to stay active, while the picnic area invites you to savor outdoor meals with family and friends. With a gated entrance, dedicated on-site management, and professional maintenance staff, you can feel secure and supported every day.\n\nLocated just moments away from I-10 and nestled in the Ysleta School District, Phoenix Apts is ideal for students and commuters alike, with Fort Bliss and the EPCC Valle Verde Campus right across the street. Our community is also pet-friendly and features convenient laundry facilities, package services, and online services to streamline your everyday tasks.\n\nDon't miss out on this opportunity to elevate your living experience. **Find your new home today—browse our availability or schedule a tour to visit our vibrant community!** Your next chapter awaits at Phoenix Apts!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-0a3b-7790-ab9b-977663961c58.webp",
  "property_featured_image_media": {
    "alt_text": "The Phoenix monument sign",
    "public_id": "019cfb53-0a3b-7790-ab9b-977663961c58",
    "storage_key": "property/6767906449167045/019cfb53-0a3b-7790-ab9b-977663961c58.webp",
    "width": 2700,
    "height": 1800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "336",
  "property_year_built": "1992",
  "property_year_renovated": null,
  "property_walk_score": "28",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.61904761904762",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed Restrictions Applied",
  "property_pet_policy_description": "Pets Welcome - Contact Leasing Office for details",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://phoenixapartmentselpaso.securecafe.com/onlineleasing/phoenix-apts-0/floorplans.aspx",
  "property_resident_portal_url": "https://phoenixapartmentselpaso.securecafe.com/residentservices/phoenix-apts-0/userlogin.aspx",
  "property_apply_now_url": "https://phoenixapartmentselpaso.securecafe.com/onlineleasing/phoenix-apts-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-6a0f-720a-9b3f-241b995ff71c.webp",
  "property_primary_logo_media": {
    "alt_text": "The Phoenix of El Paso logo.",
    "public_id": "019cfb53-6a0f-720a-9b3f-241b995ff71c",
    "storage_key": "property/6767906449167045/019cfb53-6a0f-720a-9b3f-241b995ff71c.webp",
    "width": 500,
    "height": 180
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb54-d777-7609-ab40-a43c6a8ea048.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Phoenix of El Paso logo",
    "public_id": "019cfb54-d777-7609-ab40-a43c6a8ea048",
    "storage_key": "property/6767906449167045/019cfb54-d777-7609-ab40-a43c6a8ea048.webp",
    "width": 500,
    "height": 180
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb54-e16d-7205-9b90-e2c1e985a356.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Phoenix of El Paso logo.",
    "public_id": "019cfb54-e16d-7205-9b90-e2c1e985a356",
    "storage_key": "property/6767906449167045/019cfb54-e16d-7205-9b90-e2c1e985a356.webp",
    "width": 500,
    "height": 180
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#9b6e64",
  "property_secondary_color": "#404041",
  "property_font_color": null,
  "property_color_4": "#cac4b8",
  "property_color_3": "#eae0c8",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "727 - 959",
  "property_sqft_min": "727",
  "property_sqft_max": "959",
  "property_price_range": "1030 - 1305",
  "property_price_min": "1030",
  "property_price_max": "1305",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/ThePhoenixofElPaso/",
  "property_instagram_url": "https://www.instagram.com/the_phoenix_apartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJh5OO8kFb54YRoTu6OK2as7w",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments+For+Rent&find_loc=El+Paso%2C+TX",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Phoenix Apts",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection in Your New Home",
  "property_home_amenities_blurb": "Welcome to Phoenix Apts in vibrant El Paso, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans nestled within a pet-friendly, gated community. Enjoy premium amenities like a refreshing pool, fitness center, and BBQ picnic area, all just moments from I-10 and EPCC Valle Verde Campus.",
  "property_home_floorplans_blurb": "At Phoenix Apts in El Paso, TX, elevate your living experience with thoughtfully designed floor plans tailored for every lifestyle. Each spacious apartment is infused with modern amenities, inviting comfort, and a vibrant community atmosphere. Browse our available homes today and discover the perfect space to call your own!",
  "property_home_gallery_blurb": "Welcome to Phoenix Apts, where comfort meets convenience in the heart of El Paso. Choose from spacious one, two, or three-bedroom floor plans, complemented by an array of amenities, including a refreshing pool, fitness center, and picnic areas. Picture yourself living here, embraced by luxury and community!",
  "property_home_neighborhood_blurb": "At Phoenix Apts in El Paso, your ideal home awaits! Choose from spacious one, two, or three-bedroom layouts, surrounded by vibrant attractions like the El Paso Zoo, Galerias Tec, and Memorial Park. Embrace a community rich in culture and convenience—find your perfect fit and soak up the local charm today!",
  "property_home_reviews_blurb": "At Phoenix Apts in El Paso, TX, residents rave about the vibrant community atmosphere, noting it's \"like living in a warm embrace.\" With modern amenities and a welcoming spirit, you’ll find your perfect home among friends. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Phoenix Apts in vibrant El Paso, enjoy spacious one, two, and three-bedroom layouts, surrounded by a treasure trove of local attractions. From cultural gems like the El Paso Zoo and Botanical Gardens to educational institutions like UACJ and EPCC, every convenience is just steps away. See what's around our community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Phoenix Apartments in El Paso, TX, enjoy the perfect blend of comfort and convenience. Choose from spacious one, two, or three-bedroom floor plans, and indulge in amenities like a refreshing pool, a state-of-the-art fitness center, and a welcoming clubhouse. Experience modern living near I-10 and EPCC Valle Verde Campus!",
  "property_applynow_blurb": "Experience the vibrant lifestyle at Phoenix Apts in El Paso, TX, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans, complemented by amenities like a refreshing pool, fitness center, and serene picnic areas. Ready to make your move? Secure your new home and lease online today!",
  "property_contactus_blurb": "At Phoenix Apts in vibrant El Paso, TX, our diverse floor plans—one, two, and three bedrooms—cater to all lifestyles. Whether you seek a cozy retreat or a spacious family haven, we have just the right fit for you. Have questions? Contact our leasing team today! ",
  "property_faqs_blurb": "At Phoenix Apts in vibrant El Paso, TX, our diverse floor plans—one, two, and three bedrooms—cater to every lifestyle. Dive into our FAQs page to uncover answers to your pressing questions and learn more about our welcoming community designed for comfort and convenience.",
  "property_floorplans_blurb": "At Phoenix Apts in El Paso, TX, you’ll find floor plans designed for every lifestyle. Choose from charming one-bedroom retreats to spacious three-bedroom homes. Each layout offers comfort and style, ensuring your ideal living space awaits. Browse our available apartment homes today and uncover the perfect fit for you!",
  "property_gallery_blurb": "Step into the vibrant lifestyle at Phoenix Apts in El Paso, TX. With spacious floor plans and a host of amenities—from a refreshing pool and fitness center to a welcoming clubhouse—your ideal home awaits. Picture yourself enjoying picnic areas, modern conveniences, and a supportive community. Your new adventure starts here!",
  "property_interactivemap_blurb": "Welcome to Phoenix Apts, where comfort meets convenience in El Paso, TX. Choose from stylish one, two, or three-bedroom floor plans, and enjoy top-notch amenities like a fitness center, picnic area, and a refreshing pool. Dive into our interactive community map to find your perfect home today!",
  "property_pets_blurb": "Welcome to Phoenix Apts in El Paso, TX, where modern living meets comfort. Embrace a pet-friendly lifestyle in our vibrant community, designed for relaxation and connection. Enjoy spacious layouts and inviting amenities that enhance your everyday experience. Inquiry about our leasing details and open your door to a new beginning.",
  "property_referafriend_blurb": "At Phoenix Apts in vibrant El Paso, TX, we offer thoughtfully designed floor plans—including one, two, and three-bedroom options—that cater to diverse lifestyles. Transform your living experience with fantastic amenities and a welcoming community. Great friends make great neighbors—refer a friend to join our thriving neighborhood today!",
  "property_residentaccess_blurb": "Welcome to Phoenix Apts in vibrant El Paso, TX! Choose from our stylish one, two, or three-bedroom floor plans tailored to fit your lifestyle. Ready to simplify your living experience? Log in to the resident portal now to pay rent, schedule maintenance, and enjoy seamless convenience at your fingertips!",
  "property_reviews_blurb": "At Phoenix Apts in El Paso, residents rave, \"The amenities and community atmosphere make this place feel like home.\" Join a vibrant community where comfort meets convenience. Curious about life in our apartments? See what our residents have to say about living at our community!",
  "property_created_at": "1770685019356",
  "property_scheduletour_blurb": "At Phoenix Apts in El Paso, TX, a vibrant lifestyle awaits you. Choose from our thoughtfully designed one, two, or three-bedroom floor plans that cater to your every need. Ready to make the leap? Schedule a tour today and hear firsthand what our residents love about their homes!",
  "property_thankyou_blurb": "Thank you for reaching out to Phoenix Apts in vibrant El Paso, TX! Whether you seek a cozy one-bedroom, a spacious two-bedroom, or a family-friendly three-bedroom, our community offers versatile floor plans tailored to your lifestyle. Stay tuned; our team will be in touch soon to help you find your perfect home!",
  "property_virtualtours_blurb": "Step into the vibrant lifestyle of Phoenix Apts in El Paso, TX, where modern living meets comfort. Our diverse floor plans, from cozy one-bedrooms to spacious three-bedrooms, cater to every need. Experience your future home today—take a virtual tour and envision your life here!",
  "property_copyright": "2026 All Rights Reserved. Phoenix Apts",
  "property_seo_title_home": "Phoenix Apts |  Apartments in El Paso, TX",
  "property_seo_description_home": "Live luxuriously at Phoenix Apts in El Paso! Modern floor plans, fantastic amenities, and vibrant community await. Your perfect home is just a click away!",
  "property_seo_title_floorplans": "Floor Plans | El Paso, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Phoenix Apts in El Paso, TX! Choose from stylish one, two, or three-bedroom layouts designed for comfort. Start your journey today!",
  "property_seo_title_amenities": "Amenities | El Paso, TX Apartments for Rent",
  "property_seo_description_amenities": "Enjoy a vibrant lifestyle at Phoenix Apts in El Paso, TX! From spacious floor plans to top-notch amenities, your perfect home awaits. Join us today!",
  "property_seo_title_gallery": "Gallery | Apartments in El Paso, TX",
  "property_seo_description_gallery": "Imagine life at Phoenix Apts in El Paso, TX! Enjoy spacious floor plans, top-notch amenities, and a vibrant community. Your new home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Phoenix Apts Apartments",
  "property_seo_description_virtualtours": "Step inside Phoenix Apts in El Paso, TX! Take a virtual tour of our stunning one, two, and three-bedroom apartments. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Phoenix Apts Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Phoenix Apts in El Paso, TX! Use our interactive map to discover spacious apartments with top-notch amenities and pricing.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in El Paso, TX",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood surrounding Phoenix Apts in El Paso, TX. From local favorites to must-visit spots, there’s something for everyone nearby!",
  "property_seo_title_contact": "Contact Us | Phoenix Apts",
  "property_seo_description_contact": "Experience vibrant living at Phoenix Apts in El Paso, TX! From cozy one-bedrooms to spacious three-bedrooms, our leasing team is ready to assist you today!",
  "property_seo_title_faqs": "FAQs | Apartments in El Paso, TX",
  "property_seo_description_faqs": "Get the scoop on Phoenix Apts in El Paso! Browse our FAQs for everything you need to know about our community amenities, floor plans, and more.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in El Paso, TX",
  "property_seo_description_reviews": "Join the vibrant Phoenix Apts community in El Paso, TX! Read resident reviews and discover why our amenities and welcoming atmosphere make us feel like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in El Paso, TX",
  "property_seo_description_applynow": "Elevate your lifestyle at Phoenix Apts in El Paso! One to three-bedroom homes with amazing amenities—apply online today and start your new chapter!",
  "property_seo_title_residentaccess": "Resident Access | Phoenix Apts",
  "property_seo_description_residentaccess": "Log in to Phoenix Apts' resident portal for easy rent payments, maintenance requests, and community updates. Your comfort and convenience await in El Paso!",
  "property_seo_title_referafriend": "Refer A Friend | Phoenix Apts",
  "property_seo_description_referafriend": "Refer a friend to Phoenix Apts in El Paso, TX! Great friends make great neighbors—unlock exclusive perks and enjoy a vibrant community together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Phoenix Apts",
  "property_seo_description_scheduletour": "Experience vibrant living at Phoenix Apts in El Paso, TX. Tour your future home today and embrace a lifestyle filled with comfort and community!",
  "property_seo_title_privacy": "Privacy Policy | Phoenix Apts",
  "property_seo_description_privacy": "Your privacy matters at Phoenix Apts in El Paso, TX. Learn how we protect your information and maintain a safe, welcoming community. View our policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Phoenix Apts",
  "property_seo_description_accessibility": "Experience inclusivity at Phoenix Apts in El Paso, TX. Our accessibility statement highlights our commitment to digital inclusion for all residents.",
  "property_seo_title_sitemap": "Sitemap | Phoenix Apts",
  "property_seo_description_sitemap": "Navigate your way to comfort and convenience at Phoenix Apts in El Paso, TX. Check out our sitemap for easy access to all community offerings today!",
  "property_seo_title_thankyou": "Thank You | Phoenix Apts",
  "property_seo_description_thankyou": "Thank you for reaching out to Phoenix Apts in El Paso! We appreciate your interest and will connect with you soon to help you find your perfect home.",
  "property_seo_title_pets": "Pet Policy | Apartments in El Paso, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865561434",
  "amenities": [
    {
      "id": "ec_33249088ccb64ef77d327976",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127396930",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f4ad1287590919cc231f6c21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127396931",
      "title": "Ideal Location Near Fort Bliss",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1d08c1b34a7552308e8f57f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127396932",
      "title": "Easy Access to I-10",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b1d624e5a96c82f0b2b993a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127396934",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80149d2aab49e9e5bec1b0c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127396935",
      "title": "Gated Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78e18e23a6ac843b5a19ed49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127396936",
      "title": "Spanish Speaking Staff",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7fede9c430233e161a86ef2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127396937",
      "title": "Large Parking Lot",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c6d97203d24b2972530eefa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127396938",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_368ce82c1c03bb119ead39d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127396939",
      "title": "Cardio Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_06457dac3fe669f95ad632df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127396940",
      "title": "Across from EPCC Valle Verde Campus",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4feb555b028bc338fd93538",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127396941",
      "title": "Two Onsite Laundry Centers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed97f8317ed3e91226203dcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127396942",
      "title": "Professional Maintenance Staff",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_75c42e645bb05e2cf4e37221",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127396943",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4a8a44b2c0c96c06bb0aef7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127396944",
      "title": "Electronic Payments Accepted",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_507a9f4a11490dd5ad65e2d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127396945",
      "title": "Canopy Playgrounds",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_495cb17bb9dc3ef12702d5dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127396946",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65af77c09cac7cec3b2c55f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127396947",
      "title": "Outdoor Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b33444736f3002182360cec8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "128042513",
      "title": "AT&T",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b2e758dbc67828d38d21b59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127396948",
      "title": "Short Term Leases Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d1e11ca762be09d6c3658ca8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127398409",
      "title": "Reliable Cell Reception",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4fc9805a749027a2e65e197e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127398410",
      "title": "Fully Equipped Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a4ca14307d0f88644bb6ea2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127398411",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bfe668e5a15a64f167970113",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127398412",
      "title": "Roommate Friendly Floorplan Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_08bbfaef8704e5d05ed6b72f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127398413",
      "title": "Wood Burning Fireplaces*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be3c1f33a61925579d1c5e9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127398414",
      "title": "Upgraded Fixtures",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b0525339be23d52addd5d36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127398415",
      "title": "Refrigerated Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f2d2912c4f36241288ecad58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127398416",
      "title": "Resurfaced Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53f460128566a09d8d8aba8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127398417",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7e7a66bd763fa996b7adc2dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127398418",
      "title": "Get connected to super fast internet powered by AT&T",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1622f5ff7bb7c7ba44a2f653",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127398419",
      "title": "Microwaves*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3591227092472d17672e0f7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127398420",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_810e08dbb147090649d02c91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "yardi",
      "external_id": "127398421",
      "title": "Washer & Dryer Connections*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_3e3061ec-ba62-4b9e-b910-aeffb0aea24c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20b9-bccd-717e-9675-18b0e46bc2c9.webp",
      "image_media": {
        "alt_text": "The Phoenix monument sign",
        "public_id": "019d20b9-bccd-717e-9675-18b0e46bc2c9",
        "storage_key": "property/6767906449167045/019d20b9-bccd-717e-9675-18b0e46bc2c9.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Welcome to The Phoenix apartment community, featuring a distinctive monument sign at the entrance.",
      "link": "",
      "alt_text": "The Phoenix monument sign",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-0a3b-7790-ab9b-977663961c58.webp"
    },
    {
      "id": "custom_c7057439-1ff0-4b87-bf06-1084a75cb75b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20b9-bc90-71ed-8c18-843bc22dcc13.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with walkways and trees.",
        "public_id": "019d20b9-bc90-71ed-8c18-843bc22dcc13",
        "storage_key": "property/6767906449167045/019d20b9-bc90-71ed-8c18-843bc22dcc13.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings, showcasing the architecture and landscaping, including pathways and mature trees.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with walkways and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-0a13-716a-94af-c939ea99e619.webp"
    },
    {
      "id": "custom_4a500e8c-f2ca-406c-bad3-bd2bdef461d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20b9-bcc3-73d9-bdf3-f6bd69cd0134.webp",
      "image_media": {
        "alt_text": "Basketball court and playground at apartment complex.",
        "public_id": "019d20b9-bcc3-73d9-bdf3-f6bd69cd0134",
        "storage_key": "property/6767906449167045/019d20b9-bcc3-73d9-bdf3-f6bd69cd0134.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation with a full-size basketball court and a colorful playground for kids, all set within the community grounds.",
      "link": "",
      "alt_text": "Basketball court and playground at apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-0b38-725e-8054-7751876de43b.webp"
    },
    {
      "id": "custom_39e087aa-6415-4118-818d-624c140908a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20b9-bcd3-703d-81db-4350273cb2ed.webp",
      "image_media": {
        "alt_text": "Community lounge with fireplace and view of pool area.",
        "public_id": "019d20b9-bcd3-703d-81db-4350273cb2ed",
        "storage_key": "property/6767906449167045/019d20b9-bcd3-703d-81db-4350273cb2ed.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax in the community lounge featuring a cozy fireplace, comfortable seating, and a scenic view of the sparkling outdoor pool and sun deck.",
      "link": "",
      "alt_text": "Community lounge with fireplace and view of pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-1490-735f-ac5c-525810b7835a.webp"
    },
    {
      "id": "custom_60e6fd76-25d2-4824-89be-90120202bb48",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20b9-c5af-732f-9d68-0fcdb43fc92c.webp",
      "image_media": {
        "alt_text": "Building entrance with address 7401, porch with potted plants and landscaping.",
        "public_id": "019d20b9-c5af-732f-9d68-0fcdb43fc92c",
        "storage_key": "property/6767906449167045/019d20b9-c5af-732f-9d68-0fcdb43fc92c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Welcome to our community's main entrance, featuring a clean and inviting facade with ample landscaping and potted plants, ready to greet you.",
      "link": "",
      "alt_text": "Building entrance with address 7401, porch with potted plants and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-1af2-72fc-a046-b56a294c108c.webp"
    },
    {
      "id": "custom_1b6549ae-1c1f-4bbc-980c-0b4dc53ec50f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20b9-c667-71b7-8f1a-73d3da9b59db.webp",
      "image_media": {
        "alt_text": "Entrance sign for The Phoenix apartment community with trees and a driveway",
        "public_id": "019d20b9-c667-71b7-8f1a-73d3da9b59db",
        "storage_key": "property/6767906449167045/019d20b9-c667-71b7-8f1a-73d3da9b59db.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "The Phoenix apartment community entrance features a large stone sign, well-kept lawn, and surrounding trees.",
      "link": "",
      "alt_text": "Entrance sign for The Phoenix apartment community with trees and a driveway",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167045/019cfb53-526c-70db-a5f2-ce669b69698f.webp"
    },
    {
      "id": "custom_29c526bf-6942-4750-ac69-83e3cec038a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20b9-cfce-739b-9905-97b62e42b7eb.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d20b9-cfce-739b-9905-97b62e42b7eb",
        "storage_key": "property/6767906449167045/019d20b9-cfce-739b-9905-97b62e42b7eb.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and colorful umbrellas.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-2383-7152-b8d9-1f834aacee4d.webp"
    },
    {
      "id": "custom_b934b1ad-bb12-424b-94ca-3c6ae47bda8c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20b9-d1a2-7425-a6b4-0d858d9ecbea.webp",
      "image_media": {
        "alt_text": "Two swimming pools and lounge chairs outside apartment building.",
        "public_id": "019d20b9-d1a2-7425-a6b4-0d858d9ecbea",
        "storage_key": "property/6767906449167045/019d20b9-d1a2-7425-a6b4-0d858d9ecbea.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax by the sparkling pools or soak up the sun on a lounge chair.",
      "link": "",
      "alt_text": "Two swimming pools and lounge chairs outside apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-284f-7578-8397-fa6c4f6cf76f.webp"
    },
    {
      "id": "custom_eb0b4fe2-fc13-4836-9821-49f0b78b5bf5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20b9-d7b4-7743-93e8-bbe3c35999d8.webp",
      "image_media": {
        "alt_text": "Playground with blue shade canopies and colorful equipment in a residential courtyard.",
        "public_id": "019d20b9-d7b4-7743-93e8-bbe3c35999d8",
        "storage_key": "property/6767906449167045/019d20b9-d7b4-7743-93e8-bbe3c35999d8.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Outdoor playground with shade canopies and colorful play structures in a residential apartment community courtyard.",
      "link": "",
      "alt_text": "Playground with blue shade canopies and colorful equipment in a residential courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167045/019cfb53-53ae-71dc-9fbf-07993cc2858d.webp"
    },
    {
      "id": "custom_dd6d0a5f-8e97-4a28-a5c5-58f9394e6b72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20b9-d8a8-77db-bb6d-22789929695b.webp",
      "image_media": {
        "alt_text": "Communal dining area with a table and chairs, bar seating, and a view of the pool.",
        "public_id": "019d20b9-d8a8-77db-bb6d-22789929695b",
        "storage_key": "property/6767906449167045/019d20b9-d8a8-77db-bb6d-22789929695b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy the communal dining area, perfect for gatherings or work sessions, with convenient bar seating and a view of the pool and outdoor amenities.",
      "link": "",
      "alt_text": "Communal dining area with a table and chairs, bar seating, and a view of the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-0627-717c-aea3-8f5d2b71f985.webp"
    },
    {
      "id": "custom_9a8e05ed-7c06-4f15-8a49-33eee1564b58",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20b9-e237-71bb-b576-6ae58771c306.webp",
      "image_media": {
        "alt_text": "On-site gym with cardio equipment (treadmills and stationary bikes) and mirrors.",
        "public_id": "019d20b9-e237-71bb-b576-6ae58771c306",
        "storage_key": "property/6767906449167045/019d20b9-e237-71bb-b576-6ae58771c306.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "On-site fitness center with cardio equipment in a compact room.",
      "link": "",
      "alt_text": "On-site gym with cardio equipment (treadmills and stationary bikes) and mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167045/019cfb53-5288-74d2-89df-3b3cf85c9677.webp"
    },
    {
      "id": "custom_5707cbca-f908-4da6-8799-86c06c06668d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20b9-e268-7767-9c0a-8f59e4f750b1.webp",
      "image_media": {
        "alt_text": "Business center with two computers and a printer for resident use.",
        "public_id": "019d20b9-e268-7767-9c0a-8f59e4f750b1",
        "storage_key": "property/6767906449167045/019d20b9-e268-7767-9c0a-8f59e4f750b1.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Stay connected with our convenient business center, equipped with computers and a printer for all your work and printing needs.",
      "link": "",
      "alt_text": "Business center with two computers and a printer for resident use.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-196a-7460-951f-d31048b6dd84.webp"
    },
    {
      "id": "custom_f77fd1df-0de0-4340-aa07-19b5271ac4c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20b9-eb9d-75fa-95cb-93624efe7b83.webp",
      "image_media": {
        "alt_text": "Apartment building entrance with coffee station and seating area.",
        "public_id": "019d20b9-eb9d-75fa-95cb-93624efe7b83",
        "storage_key": "property/6767906449167045/019d20b9-eb9d-75fa-95cb-93624efe7b83.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Welcome guests with a coffee station in the apartment building's entrance. This community space is inviting and functional.",
      "link": "",
      "alt_text": "Apartment building entrance with coffee station and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-1fcf-774c-8214-823f4654af0e.webp"
    },
    {
      "id": "custom_863abca0-878e-4a4f-87f3-ada1ffb18273",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20b9-ec8a-74e0-a6f6-100004ee4e2c.webp",
      "image_media": {
        "alt_text": "Communal laundry room with white washers on left and dryers on right along a tiled floor.",
        "public_id": "019d20b9-ec8a-74e0-a6f6-100004ee4e2c",
        "storage_key": "property/6767906449167045/019d20b9-ec8a-74e0-a6f6-100004ee4e2c.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Bright shared laundry facility in a multifamily building, with washers and dryers along both walls.",
      "link": "",
      "alt_text": "Communal laundry room with white washers on left and dryers on right along a tiled floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167045/019cfb53-5271-7659-9ed1-471da9e1ae27.webp"
    },
    {
      "id": "custom_178f3d9a-3f38-4c60-b314-054c975b27fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20b9-f573-77fd-bceb-c7c7b36146ea.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment community laundry center with a gated area and landscaping.",
        "public_id": "019d20b9-f573-77fd-bceb-c7c7b36146ea",
        "storage_key": "property/6767906449167045/019d20b9-f573-77fd-bceb-c7c7b36146ea.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Exterior shot of the property's laundry center building, with a doorway and sign, surrounded by landscaping.",
      "link": "",
      "alt_text": "Exterior view of the apartment community laundry center with a gated area and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167045/019cfb53-536d-72ed-ba43-5c351fd7f529.webp"
    },
    {
      "id": "custom_04c059cd-6bd8-4cd2-ad4d-a9aaa551f17a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20b9-f56e-7720-9151-bf0b4b79ef66.webp",
      "image_media": {
        "alt_text": "Living room with a plush couch, decorative wall art, and a coffee table.",
        "public_id": "019d20b9-f56e-7720-9151-bf0b4b79ef66",
        "storage_key": "property/6767906449167045/019d20b9-f56e-7720-9151-bf0b4b79ef66.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Relax in this inviting living room featuring a comfortable tufted sofa and stylish decor, perfect for unwinding or entertaining guests.",
      "link": "",
      "alt_text": "Living room with a plush couch, decorative wall art, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-0697-7702-bf3b-e67dd20b4005.webp"
    },
    {
      "id": "custom_f7491f77-4669-4f51-961d-99581db198de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-0107-71fc-a0db-b32c97296beb.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, wooden headboard, nightstand with a lamp, and a framed picture of a bison.",
        "public_id": "019d20ba-0107-71fc-a0db-b32c97296beb",
        "storage_key": "property/6767906449167045/019d20ba-0107-71fc-a0db-b32c97296beb.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Relax in the comfort of our beautifully appointed bedrooms, featuring a queen-sized bed, tasteful decor, and ample natural light.",
      "link": "",
      "alt_text": "Bedroom with a queen-sized bed, wooden headboard, nightstand with a lamp, and a framed picture of a bison.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-063c-7426-91be-774ceb4e62ac.webp"
    },
    {
      "id": "custom_b572abab-219e-424c-860c-a1ba352d5e7b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-06e0-745e-9ec1-2846e6b91e6b.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a yellow vanity, white sink, toilet, and a white bathtub with a striped shower curtain.",
        "public_id": "019d20ba-06e0-745e-9ec1-2846e6b91e6b",
        "storage_key": "property/6767906449167045/019d20ba-06e0-745e-9ec1-2846e6b91e6b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a yellow vanity, a white sink, toilet, and bathtub with a decorative shower curtain, perfect for your home.",
      "link": "",
      "alt_text": "Modern bathroom with a yellow vanity, white sink, toilet, and a white bathtub with a striped shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-061e-743c-80e8-b03228cf250f.webp"
    },
    {
      "id": "custom_50addcfb-5fc4-49a5-bfd8-f132c48a67fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-09bb-70b9-b945-0e184d2150f2.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, decorative pillows, a bedside table with books, and a wall clock.",
        "public_id": "019d20ba-09bb-70b9-b945-0e184d2150f2",
        "storage_key": "property/6767906449167045/019d20ba-09bb-70b9-b945-0e184d2150f2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Relax and unwind in this comfortable bedroom, featuring a plush queen-size bed and charming decorative accents. A perfect retreat after a long day.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, decorative pillows, a bedside table with books, and a wall clock.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-063e-73c6-9750-cb03ebb0ae8f.webp"
    },
    {
      "id": "custom_d15d3940-8284-415b-bcc6-8ca71aafa4cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-0aa6-764d-897d-a0b5f09d3634.webp",
      "image_media": {
        "alt_text": "Living room with a gray sofa, coffee table, and large window.",
        "public_id": "019d20ba-0aa6-764d-897d-a0b5f09d3634",
        "storage_key": "property/6767906449167045/019d20ba-0aa6-764d-897d-a0b5f09d3634.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living room with a cozy gray sofa, accent pillows, a coffee table, and a large window with natural light.",
      "link": "",
      "alt_text": "Living room with a gray sofa, coffee table, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-0882-760e-8569-ef0de877644c.webp"
    },
    {
      "id": "custom_cb15e62d-b97f-4b05-af87-244039dfb1ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-1326-77b3-9080-87edfc4f84d8.webp",
      "image_media": {
        "alt_text": "Closet with stacked washer and dryer, shelves with decorative baskets.",
        "public_id": "019d20ba-1326-77b3-9080-87edfc4f84d8",
        "storage_key": "property/6767906449167045/019d20ba-1326-77b3-9080-87edfc4f84d8.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your convenience, with overhead shelving for storage.",
      "link": "",
      "alt_text": "Closet with stacked washer and dryer, shelves with decorative baskets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-0b14-7139-9ddc-f40d55081ded.webp"
    },
    {
      "id": "custom_d4af4151-81ab-4c6b-99bb-e3e24be9699b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-1513-71bf-bb5a-d8badf712c04.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, bedside table, and dresser with mirrors.",
        "public_id": "019d20ba-1513-71bf-bb5a-d8badf712c04",
        "storage_key": "property/6767906449167045/019d20ba-1513-71bf-bb5a-d8badf712c04.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "This bedroom features a queen-size bed with a patterned comforter, a wooden bedside table with a lamp, and a dresser with decorative mirrors.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, bedside table, and dresser with mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-14ea-71db-8070-68de926f8cce.webp"
    },
    {
      "id": "custom_ac4c38ad-1d15-4bc1-bf70-7283aa50c70b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-188e-759d-9f48-ef825bd9391b.webp",
      "image_media": {
        "alt_text": "Kitchen with yellow cabinets, white appliances, and a double sink.",
        "public_id": "019d20ba-188e-759d-9f48-ef825bd9391b",
        "storage_key": "property/6767906449167045/019d20ba-188e-759d-9f48-ef825bd9391b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring yellow cabinetry, white appliances including a microwave, stove, dishwasher, and refrigerator, all complemented by a double sink and ample counter space.",
      "link": "",
      "alt_text": "Kitchen with yellow cabinets, white appliances, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-1957-70bc-937a-2679b045024f.webp"
    },
    {
      "id": "custom_38f8d5a2-9e56-4fb7-8f15-4d720f2135ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-1c9f-7058-8a77-dc4036013149.webp",
      "image_media": {
        "alt_text": "Living room with gray sofa, coffee table, TV, and large window.",
        "public_id": "019d20ba-1c9f-7058-8a77-dc4036013149",
        "storage_key": "property/6767906449167045/019d20ba-1c9f-7058-8a77-dc4036013149.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a plush gray sofa, a modern coffee table, and a wall-mounted TV. Large windows allow natural light to fill the space.",
      "link": "",
      "alt_text": "Living room with gray sofa, coffee table, TV, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-1dfb-72bd-ba6f-5210aa763b28.webp"
    },
    {
      "id": "custom_aceefa0a-0327-4f10-8af6-e39fcc67229b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-1e52-7029-942d-13c93d8595ee.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with dining table and chairs.",
        "public_id": "019d20ba-1e52-7029-942d-13c93d8595ee",
        "storage_key": "property/6767906449167045/019d20ba-1e52-7029-942d-13c93d8595ee.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area featuring a dining table, chairs, and ample cabinet space.",
      "link": "",
      "alt_text": "Living room and kitchen area with dining table and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-2115-7667-94b0-71792fd1d24d.webp"
    },
    {
      "id": "custom_edffa872-054c-4fd2-9767-95a469e0b439",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-2626-76a1-9995-17ccfcae9921.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with table and chairs",
        "public_id": "019d20ba-2626-76a1-9995-17ccfcae9921",
        "storage_key": "property/6767906449167045/019d20ba-2626-76a1-9995-17ccfcae9921.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A stylish kitchen and dining area featuring a round table with upholstered chairs, set for a meal, with modern appliances visible.",
      "link": "",
      "alt_text": "Kitchen and dining area with table and chairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-2417-758d-b03c-c9d9b2b84af0.webp"
    },
    {
      "id": "custom_e562c4d5-cac0-4648-b887-5eb4e932bf0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-276c-7786-91b3-085b79145049.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving",
        "public_id": "019d20ba-276c-7786-91b3-085b79145049",
        "storage_key": "property/6767906449167045/019d20ba-276c-7786-91b3-085b79145049.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample white wire shelving and neutral carpet. Perfect for organizing all your belongings.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-26a3-703a-8b52-697b68a282a6.webp"
    },
    {
      "id": "custom_8a74e4de-2fe3-4292-af6f-2003097e9172",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-3009-76af-8603-3bb4b4164162.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with yellow cabinets and white appliances.",
        "public_id": "019d20ba-3009-76af-8603-3bb4b4164162",
        "storage_key": "property/6767906449167045/019d20ba-3009-76af-8603-3bb4b4164162.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy meals in the dining area adjacent to the kitchen featuring modern appliances and ample cabinet space.",
      "link": "",
      "alt_text": "Dining area and kitchen with yellow cabinets and white appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-289e-7117-b723-f8b234c086e0.webp"
    },
    {
      "id": "custom_ed465c0c-7f01-4ee6-b7a8-d11bf5881b61",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-31e7-7658-ac8d-bfbf3baf71a0.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub.",
        "public_id": "019d20ba-31e7-7658-ac8d-bfbf3baf71a0",
        "storage_key": "property/6767906449167045/019d20ba-31e7-7658-ac8d-bfbf3baf71a0.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring a double vanity, a private toilet area, and a bathtub with a decorative shower curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-2a36-760b-8f72-468443abbafe.webp"
    },
    {
      "id": "custom_e24c56b6-b62e-48fa-9060-9235a52b5d95",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-34b6-705d-8cb0-0198c522c212.webp",
      "image_media": {
        "alt_text": "Kitchen with yellow cabinets, white appliances, and a double sink.",
        "public_id": "019d20ba-34b6-705d-8cb0-0198c522c212",
        "storage_key": "property/6767906449167045/019d20ba-34b6-705d-8cb0-0198c522c212.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen with warm yellow cabinetry, double sink, and full-size appliances.",
      "link": "",
      "alt_text": "Kitchen with yellow cabinets, white appliances, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167045/019cfb53-53dd-7517-8b3e-a8103c45174b.webp"
    },
    {
      "id": "custom_b5246b68-3ceb-4f64-978f-3624098d6c52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-38f8-7103-974d-0ca59523b585.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a gray sofa, coffee table, large window, and neutral decor.",
        "public_id": "019d20ba-38f8-7103-974d-0ca59523b585",
        "storage_key": "property/6767906449167045/019d20ba-38f8-7103-974d-0ca59523b585.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Bright living area in a modern apartment with a gray sofa, coffee table, plants, and wall art.",
      "link": "",
      "alt_text": "Living room in an apartment with a gray sofa, coffee table, large window, and neutral decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167045/019cfb53-53a0-74c4-9039-20e0866493bb.webp"
    },
    {
      "id": "custom_7060e02a-9199-44ac-9622-3faff663c2e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-3ec6-7238-b8b0-154ce9ad79a7.webp",
      "image_media": {
        "alt_text": "Compact apartment kitchen and dining area with yellow cabinets, a round table, and gray chairs.",
        "public_id": "019d20ba-3ec6-7238-b8b0-154ce9ad79a7",
        "storage_key": "property/6767906449167045/019d20ba-3ec6-7238-b8b0-154ce9ad79a7.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Bright dining nook and kitchen in a compact apartment, featuring yellow cabinets, a round table, and decorative wall mirror.",
      "link": "",
      "alt_text": "Compact apartment kitchen and dining area with yellow cabinets, a round table, and gray chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167045/019cfb53-5357-707e-883f-9ba7944551d9.webp"
    },
    {
      "id": "custom_db148b92-a18c-4e3e-a894-a573b0b57beb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-4204-775d-9441-d32295af9682.webp",
      "image_media": {
        "alt_text": "Open-concept living room and kitchen in an apartment with yellow cabinets and a round dining table.",
        "public_id": "019d20ba-4204-775d-9441-d32295af9682",
        "storage_key": "property/6767906449167045/019d20ba-4204-775d-9441-d32295af9682.webp",
        "width": 2000,
        "height": 500
      },
      "title": "Apartment",
      "description": "Interior view of an apartment showing a cozy living space and a bright kitchen with yellow cabinetry and a round dining table.",
      "link": "",
      "alt_text": "Open-concept living room and kitchen in an apartment with yellow cabinets and a round dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167045/019cfb53-6a33-72ce-bdbe-1b29e81f6896.webp"
    },
    {
      "id": "custom_0a6f597c-9a27-4730-b56d-9655b2ad14f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-4737-7724-b763-1edb110c48c1.webp",
      "image_media": {
        "alt_text": "Panoramic city skyline with foreground grasses and a purple sunset sky.",
        "public_id": "019d20ba-4737-7724-b763-1edb110c48c1",
        "storage_key": "property/6767906449167045/019d20ba-4737-7724-b763-1edb110c48c1.webp",
        "width": 1998,
        "height": 749
      },
      "title": "Lifestyle",
      "description": "Panoramic downtown skyline view, ideal for exterior property ambiance and branding.",
      "link": "",
      "alt_text": "Panoramic city skyline with foreground grasses and a purple sunset sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167045/019cfb53-6b74-713c-b3e4-397608a3faf5.webp"
    },
    {
      "id": "custom_fab67cb7-0ca9-4b2e-b4e6-6f07bab267a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-4b15-73da-abd7-fe31cc1b9332.webp",
      "image_media": {
        "alt_text": "Person holding a white travel mug beside a bicycle outdoors.",
        "public_id": "019d20ba-4b15-73da-abd7-fe31cc1b9332",
        "storage_key": "property/6767906449167045/019d20ba-4b15-73da-abd7-fe31cc1b9332.webp",
        "width": 698,
        "height": 797
      },
      "title": "Lifestyle",
      "description": "Casual outdoor lifestyle photo of a person with a bicycle and a white travel mug.",
      "link": "",
      "alt_text": "Person holding a white travel mug beside a bicycle outdoors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167045/019cfb53-7393-71df-b682-6dacbd117241.webp"
    },
    {
      "id": "custom_9c6224e1-44a0-4816-98b8-a464b2fb668a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d20ba-50ca-7443-a638-7a8d1238c4e1.webp",
      "image_media": {
        "alt_text": "Children with backpacks line up to board a yellow school bus outdoors.",
        "public_id": "019d20ba-50ca-7443-a638-7a8d1238c4e1",
        "storage_key": "property/6767906449167045/019d20ba-50ca-7443-a638-7a8d1238c4e1.webp",
        "width": 788,
        "height": 663
      },
      "title": "Lifestyle",
      "description": "Kids with backpacks boarding a school bus in a parking lot, illustrating family-friendly community life.",
      "link": "",
      "alt_text": "Children with backpacks line up to board a yellow school bus outdoors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167045/019cfb53-743c-7367-b322-803da68af47a.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_6901f410-a9d2-4faf-86af-c410dee686ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Teppanyaki Grill & Buffet",
      "poi_type": "Restaurants",
      "poi_address": "8300 Gtwy Blvd E, El Paso, TX 79907, USA",
      "poi_short_description": "Casual buffet restaurant with a wide variety of classic Chinese & Japanese dishes, including sushi.",
      "poi_long_description": "Diners say this buffet restaurant offers a wide variety of Asian food, including sushi, Chinese dishes, and a Mongolian grill, as well as American options like steak and ribs. They also highlight the friendly and attentive staff, and the reasonable price for the all-you-can-eat option.\n\nSome reviews mention the restaurant can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-1960-75da-b4f7-fdb440b5cd64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1960-75da-b4f7-fdb440b5cd64",
        "storage_key": "property/6767906449167045/019d270e-1960-75da-b4f7-fdb440b5cd64.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://ocs.ink/Teppanyaki_MenuPrice",
      "poi_directions_map_url": "https://maps.google.com/?cid=4709443183176625985&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "teppanyaki-grill--buffet",
      "poi_latitude": "31.7408162",
      "poi_longitude": "-106.328057",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-595-6980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5596-76da-9f30-e66edec82e6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5596-76da-9f30-e66edec82e6e",
        "storage_key": "property/6767906449167045/019d270e-5596-76da-9f30-e66edec82e6e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlRseKF9D54YRQa8gl59NW0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_bd27f086-2c49-4f8d-bce8-a1d81c960d6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "L & J Cafe",
      "poi_type": "Restaurants",
      "poi_address": "3622 E Missouri Ave, El Paso, TX 79903, USA",
      "poi_short_description": "A local landmark dating back to 1927, this family-run eatery serves regional Mexican dishes & beers.",
      "poi_long_description": "People say this Mexican restaurant serves delicious and flavorful dishes, including enchiladas, burritos, and tacos. They highlight the reasonable prices, generous portions, and authentic, family-owned atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-18ed-7519-9901-afd98f0640a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-18ed-7519-9901-afd98f0640a6",
        "storage_key": "property/6767906449167045/019d270e-18ed-7519-9901-afd98f0640a6.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://ljcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=253529114313290020&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "l--j-cafe",
      "poi_latitude": "31.7795154",
      "poi_longitude": "-106.4497953",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-566-8418",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5596-76da-9f30-e66edec82e6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5596-76da-9f30-e66edec82e6e",
        "storage_key": "property/6767906449167045/019d270e-5596-76da-9f30-e66edec82e6e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy58M-oRZ54YRJPHc3mK3hAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_90e11cad-bda6-45ad-bb93-83cf69f2475e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "La Nueva Central",
      "poi_type": "Restaurants",
      "poi_address": "Av. Tecnológico 1561, Villa Hermosa, 32510 Juárez, Chih., Mexico",
      "poi_short_description": "Laid-back, circa-1958 restaurant offering international dishes in a colorful dining area.",
      "poi_long_description": "People say this restaurant offers a wide variety of dishes, including Mexican, Chinese, and breakfast options, and is open 24 hours. They highlight the affordable prices and generous portions. They also like the friendly and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-19ab-704a-821b-80783d157f66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-19ab-704a-821b-80783d157f66",
        "storage_key": "property/6767906449167045/019d270e-19ab-704a-821b-80783d157f66.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://www.lanuevacentral.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2126757974413372569&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-nueva-central",
      "poi_latitude": "31.7196306",
      "poi_longitude": "-106.4248246",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+52 656 703 8199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5596-76da-9f30-e66edec82e6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5596-76da-9f30-e66edec82e6e",
        "storage_key": "property/6767906449167045/019d270e-5596-76da-9f30-e66edec82e6e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWxOK3hFc54YRmWwjFBzDgx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c6a2fe50-2cc0-4daf-93b6-80ca59facdd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "10729 Gateway Blvd W, El Paso, TX 79935, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, chicken, and ribs. They also highlight the good value, lively atmosphere, and attentive service.\n\nSome reviews mention there can be a long wait.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-192b-743a-9d0f-21e81e890195.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-192b-743a-9d0f-21e81e890195",
        "storage_key": "property/6767906449167045/019d270e-192b-743a-9d0f-21e81e890195.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/el-paso-gateway-west-blvd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=7533061792699482454&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "31.7512399",
      "poi_longitude": "-106.3414628",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-591-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5596-76da-9f30-e66edec82e6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5596-76da-9f30-e66edec82e6e",
        "storage_key": "property/6767906449167045/019d270e-5596-76da-9f30-e66edec82e6e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKd43xq1E54YRVoHr4MnPimg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_c75f7d66-bc9b-414c-ad8e-223cd9556330",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "8867 Gateway Blvd W, El Paso, TX 79925, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken strips and Cane's sauce. They highlight the food is consistently good and the service is efficient. They also like the friendly staff and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-1dfb-71e5-86be-f9b4b80d5534.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1dfb-71e5-86be-f9b4b80d5534",
        "storage_key": "property/6767906449167045/019d270e-1dfb-71e5-86be-f9b4b80d5534.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/tx/el-paso/8867-gateway-blvd-w",
      "poi_directions_map_url": "https://maps.google.com/?cid=16715938771041208080&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "31.771909",
      "poi_longitude": "-106.3763932",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-599-9118",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5596-76da-9f30-e66edec82e6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5596-76da-9f30-e66edec82e6e",
        "storage_key": "property/6767906449167045/019d270e-5596-76da-9f30-e66edec82e6e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV3aoIhpb54YREEcXV7_x-uc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_bfdd3a6d-b8e4-40ed-9dc3-73cdcdfc2adf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Cielo Vista Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "8401 Gateway Blvd W, El Paso, TX 79925, USA",
      "poi_short_description": "Classy retail complex with 2 floors of department stores & specialty shops, plus a movie theater.",
      "poi_long_description": "People say this shopping center offers a wide variety of shops and department stores. They also highlight the clean, friendly atmosphere, and the good service.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-1e4e-77f5-8191-c896b03d22e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1e4e-77f5-8191-c896b03d22e0",
        "storage_key": "property/6767906449167045/019d270e-1e4e-77f5-8191-c896b03d22e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/cielo-vista",
      "poi_directions_map_url": "https://maps.google.com/?cid=11576646027705312160&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cielo-vista-mall",
      "poi_latitude": "31.7750435",
      "poi_longitude": "-106.37921",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-779-7070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5578-759d-972b-160f32cd073d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5578-759d-972b-160f32cd073d",
        "storage_key": "property/6767906449167045/019d270e-5578-759d-972b-160f32cd073d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJo5kkYlRa54YRoOPP-zmCqKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_064bb7f6-6ff6-4ae5-bcd4-348668a92398",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Plaza Las Misiones",
      "poi_type": "Shopping & Retail",
      "poi_address": "Blvd. Teófilo Borunda 8682, 32664 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-1e67-7294-bf88-82df01f7abff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1e67-7294-bf88-82df01f7abff",
        "storage_key": "property/6767906449167045/019d270e-1e67-7294-bf88-82df01f7abff.webp",
        "width": 1200,
        "height": 676
      },
      "poi_business_url": "https://plazalasmisiones.mx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12127736051292602934&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "plaza-las-misiones",
      "poi_latitude": "31.6867107",
      "poi_longitude": "-106.409167",
      "poi_miles_from_property": "12.4",
      "poi_walking_minutes": "4 hours 37 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+52 656 648 2230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5578-759d-972b-160f32cd073d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5578-759d-972b-160f32cd073d",
        "storage_key": "property/6767906449167045/019d270e-5578-759d-972b-160f32cd073d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcXWLN4Zd54YRNoL-4q5fTqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_bfc630c3-dfb1-4783-9670-b42578323b35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Plaza Sendero",
      "poi_type": "Shopping & Retail",
      "poi_address": "Francisco Villareal Torres 2050-A, C. Valle del Sol, 32422 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, products, and services, including clothing, shoes, sports equipment, and a cinema. They highlight the clean and spacious environment, and the family-friendly atmosphere. They also like the convenient parking and the many dining options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-2034-72a8-9d55-6ebda5597aca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2034-72a8-9d55-6ebda5597aca",
        "storage_key": "property/6767906449167045/019d270e-2034-72a8-9d55-6ebda5597aca.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.sendero.com.mx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16591975296251198647&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "plaza-sendero",
      "poi_latitude": "31.6929981",
      "poi_longitude": "-106.3801961",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5578-759d-972b-160f32cd073d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5578-759d-972b-160f32cd073d",
        "storage_key": "property/6767906449167045/019d270e-5578-759d-972b-160f32cd073d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvcY_guJc54YRt_wbt5-JQuY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_10724f02-0341-4262-8085-fa23b08b3de2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Rio Grande Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "Av. Paseo Triunfo de la República 4450, Monumental, 32310 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including well-known brands, and a nice food court. They highlight the convenient location, ample parking, and family-friendly atmosphere. They also like the clean and well-maintained facilities, and the helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-2276-74cd-9a23-4aca197c5e55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2276-74cd-9a23-4aca197c5e55",
        "storage_key": "property/6767906449167045/019d270e-2276-74cd-9a23-4aca197c5e55.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/RGMall",
      "poi_directions_map_url": "https://maps.google.com/?cid=12762927341018264293&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rio-grande-mall",
      "poi_latitude": "31.735368",
      "poi_longitude": "-106.4470445",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+52 656 251 0496",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5578-759d-972b-160f32cd073d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5578-759d-972b-160f32cd073d",
        "storage_key": "property/6767906449167045/019d270e-5578-759d-972b-160f32cd073d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJl5csO1FZ54YR5bKDt8sGH7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6ae7443b-92ed-4463-92f1-c073016b7bc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Galerias Tec",
      "poi_type": "Shopping & Retail",
      "poi_address": "Av. Tecnológico 1770, Fuentes del Valle, 32500 Juárez, Chih., Mexico",
      "poi_short_description": "Retail chain selling health- & sports-related vitamins, supplements & herbs, plus drinks & snacks.",
      "poi_long_description": "People say this shopping center offers a wide variety of shops and has ample parking. They also highlight the convenient access, the presence of a movie theater, and the availability of a supermarket.\n\nOther reviews mention the shopping center can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-23b2-7299-aadb-b26f1a563d5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-23b2-7299-aadb-b26f1a563d5f",
        "storage_key": "property/6767906449167045/019d270e-23b2-7299-aadb-b26f1a563d5f.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17123123586951246549&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "galerias-tec",
      "poi_latitude": "31.7143933",
      "poi_longitude": "-106.4220198",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5578-759d-972b-160f32cd073d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5578-759d-972b-160f32cd073d",
        "storage_key": "property/6767906449167045/019d270e-5578-759d-972b-160f32cd073d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP2RfBxRc54YR1XJXHS6Ooe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a16c1f9d-fe61-4b4f-a255-e8b71324b7e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "UACJ - ICB Instituto de Ciencias Biomedicas",
      "poi_type": "Education",
      "poi_address": "Av. Plutarco Elías Calles 1210, Alfa, 32310 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-236d-7095-92ee-74e6e263bcea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-236d-7095-92ee-74e6e263bcea",
        "storage_key": "property/6767906449167045/019d270e-236d-7095-92ee-74e6e263bcea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.uacj.mx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17836586955962659904&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uacj---icb-instituto-de-ciencias-biomedicas",
      "poi_latitude": "31.7474767",
      "poi_longitude": "-106.4430786",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+52 656 688 2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5603-7482-adce-16a34e6e9a92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5603-7482-adce-16a34e6e9a92",
        "storage_key": "property/6767906449167045/019d270e-5603-7482-adce-16a34e6e9a92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2eTWal9Z54YRQDSFi1VJiPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_57b32d20-6c92-47d0-81a4-c77f3e5cbb01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "El Paso Community College - Valle Verde Campus",
      "poi_type": "Education",
      "poi_address": "919 Hunter Dr, El Paso, TX 79915, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-2506-701d-8f59-f72ad3df14c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2506-701d-8f59-f72ad3df14c7",
        "storage_key": "property/6767906449167045/019d270e-2506-701d-8f59-f72ad3df14c7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://epcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12932995833553831033&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-community-college---valle-verde-campus",
      "poi_latitude": "31.7521673",
      "poi_longitude": "-106.3697966",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-831-3722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5603-7482-adce-16a34e6e9a92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5603-7482-adce-16a34e6e9a92",
        "storage_key": "property/6767906449167045/019d270e-5603-7482-adce-16a34e6e9a92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG6fyDhhb54YReUSVTDA7e7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_71c534af-c1a8-4450-867f-85051d7023c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Institute of Social Sciences and Administration",
      "poi_type": "Education",
      "poi_address": "Av. Universidad, Av. Heroico Colegio Militar y, Chamizal, 32300 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-283f-74ae-9504-cc04cd2bcf1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-283f-74ae-9504-cc04cd2bcf1c",
        "storage_key": "property/6767906449167045/019d270e-283f-74ae-9504-cc04cd2bcf1c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.uacj.mx/ICSA/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1922637532778773215&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "institute-of-social-sciences-and-administration",
      "poi_latitude": "31.7568996",
      "poi_longitude": "-106.4483951",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+52 656 688 3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5603-7482-adce-16a34e6e9a92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5603-7482-adce-16a34e6e9a92",
        "storage_key": "property/6767906449167045/019d270e-5603-7482-adce-16a34e6e9a92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP2FS7WRZ54YR37ocRaaUrho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c4c625fd-7f6c-4c64-9fa6-ef67e78cbee2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Technological Institute of Ciudad Juárez",
      "poi_type": "Education",
      "poi_address": "Av. Tecnológico 1340, Fuentes del Valle, 32500 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-2805-7671-8ddb-afcd0db7d504.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2805-7671-8ddb-afcd0db7d504",
        "storage_key": "property/6767906449167045/019d270e-2805-7671-8ddb-afcd0db7d504.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6388190274704984187&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "technological-institute-of-ciudad-jurez",
      "poi_latitude": "31.7200523",
      "poi_longitude": "-106.4213704",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+52 656 688 2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5603-7482-adce-16a34e6e9a92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5603-7482-adce-16a34e6e9a92",
        "storage_key": "property/6767906449167045/019d270e-5603-7482-adce-16a34e6e9a92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSz79ScJd54YRe0hlcTVpp1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f7d8162c-84c7-4da0-a919-710c92b74163",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Instituto de Ciencias Biomédicas",
      "poi_type": "Education",
      "poi_address": "Av. Benjamín Franklin no. 4650, Zona Pronaf Condominio La Plata, 32310 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-2884-7687-9ffc-d0a348cb7f0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2884-7687-9ffc-d0a348cb7f0a",
        "storage_key": "property/6767906449167045/019d270e-2884-7687-9ffc-d0a348cb7f0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.uacj.mx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12645114267800600454&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "instituto-de-ciencias-biomdicas",
      "poi_latitude": "31.746376",
      "poi_longitude": "-106.4437816",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+52 656 688 1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5603-7482-adce-16a34e6e9a92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5603-7482-adce-16a34e6e9a92",
        "storage_key": "property/6767906449167045/019d270e-5603-7482-adce-16a34e6e9a92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJId5r515Z54YRhn96DG54fK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_52175094-bb61-419b-a314-e3b93bb3f705",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "El Paso Zoo and Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "Train Station, 4001 E Paisano Dr, El Paso, TX 79905, USA",
      "poi_short_description": "220 African, American & Asian species residing in facsimiles of natural habitats in a 35-acre park.",
      "poi_long_description": "People say this zoo offers a variety of animals, including penguins and giraffes, and has a fun splash pad and playground for children. They also highlight the affordable price, convenient size for families with young children, and friendly staff.\n\nOther reviews mention some exhibits can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-2baf-77ad-a23c-dd8b16d2de7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2baf-77ad-a23c-dd8b16d2de7b",
        "storage_key": "property/6767906449167045/019d270e-2baf-77ad-a23c-dd8b16d2de7b.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://www.elpasozoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9154948632860338008&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-zoo-and-botanical-gardens",
      "poi_latitude": "31.7690489",
      "poi_longitude": "-106.4448897",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 915-212-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5597-76cb-9243-33687adfb1de",
        "storage_key": "property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7ASQX5Z54YRWKeWzkbpDH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_d7a0999e-c4c7-4cd6-9e59-c0af6698bb17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Estadio Olímpico Benito Juárez",
      "poi_type": "Entertainment",
      "poi_address": "Av. Heroico Colegio Militar 51, Chamizal, 32300 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "People say this stadium offers a passionate atmosphere and a good view of the game. They highlight the well-organized events, the safe environment, and the variety of snacks. They also like the convenient parking and easy access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-2dc3-77ec-a9fd-e218d0ef8a68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2dc3-77ec-a9fd-e218d0ef8a68",
        "storage_key": "property/6767906449167045/019d270e-2dc3-77ec-a9fd-e218d0ef8a68.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2843042972014026862&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "estadio-olmpico-benito-jurez",
      "poi_latitude": "31.7526757",
      "poi_longitude": "-106.4682618",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+52 656 612 7417",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-58ec-7261-8bc1-c1aa03594259.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-58ec-7261-8bc1-c1aa03594259",
        "storage_key": "property/6767906449167045/019d270e-58ec-7261-8bc1-c1aa03594259.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUR_bhxNZ54YRbiARHIWEdCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_f12bac0f-18c7-4424-8132-bc8bb5f3a89e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "El Paso County Coliseum",
      "poi_type": "Entertainment",
      "poi_address": "4100 E Paisano Dr, El Paso, TX 79905, USA",
      "poi_short_description": "Venue known for its many concerts and events, including monster trucks and a Van Gogh exhibit.",
      "poi_long_description": "People say this arena hosts awesome events like wrestling, rock concerts, and hockey games. They also highlight the fun and exciting atmosphere, and the good memories made at events.\n\nOther reviews mention the infrastructure can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-2d47-777b-adbc-efc37e435a86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2d47-777b-adbc-efc37e435a86",
        "storage_key": "property/6767906449167045/019d270e-2d47-777b-adbc-efc37e435a86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://epcountycoliseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14120659578983158164&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-county-coliseum",
      "poi_latitude": "31.766561",
      "poi_longitude": "-106.4432224",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-534-4229",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5597-76cb-9243-33687adfb1de",
        "storage_key": "property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ52jcy31Z54YRlBGClxKp9sM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_d8a0d47f-5672-4501-b95c-3dbab8c57c09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Casa De Juan Gabriel",
      "poi_type": "Entertainment",
      "poi_address": "Colombia 157, Partido Romero, 32030 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "People say this museum offers a unique and immersive experience, showcasing the life and work of a famous musician. They highlight the beautiful house, well-maintained grounds, and the interesting exhibits, including a gallery of costumes and personal items. They also like the knowledgeable and friendly guides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-2dc8-7371-973f-4edc09901f9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2dc8-7371-973f-4edc09901f9d",
        "storage_key": "property/6767906449167045/019d270e-2dc8-7371-973f-4edc09901f9d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://museojuangabriel.mx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14407753837179933882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "casa-de-juan-gabriel",
      "poi_latitude": "31.7387526",
      "poi_longitude": "-106.469558",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5952-72fd-b9b7-b44275f53d21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5952-72fd-b9b7-b44275f53d21",
        "storage_key": "property/6767906449167045/019d270e-5952-72fd-b9b7-b44275f53d21.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJw80TgjlZ54YRupRhhMef8sc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_02d913ee-14d6-4b81-ab03-8b22afcb5f2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Las Anitas",
      "poi_type": "Entertainment",
      "poi_address": "Calle Ramón Rayón, Av. Waterfill No. 1658, 32590 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "People say this water park offers a variety of pools and slides. They also highlight the convenient amenities, such as changing rooms, bathrooms, and on-site shops selling snacks, drinks, and toys.\n\nSome reviews mention certain areas can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-3173-737d-b72d-bca36a50987b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3173-737d-b72d-bca36a50987b",
        "storage_key": "property/6767906449167045/019d270e-3173-737d-b72d-bca36a50987b.webp",
        "width": 1121,
        "height": 630
      },
      "poi_business_url": "http://mundoacuaticoanita.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18391859672914372676&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "las-anitas",
      "poi_latitude": "31.6775302",
      "poi_longitude": "-106.3465576",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+52 656 682 1486",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5597-76cb-9243-33687adfb1de",
        "storage_key": "property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTzJ3K8tC54YRRKjkou0CPf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_fb58b432-8953-4f11-874d-7a9da159b9fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Gimnasio Universitario UACJ",
      "poi_type": "Health and Wellness",
      "poi_address": "C. Ignacio Mejía s/n, Margaritas, 32315 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a spacious venue for sporting events, graduations, and concerts, with individual seating and good sound and lighting. They highlight the clean facilities and well-maintained basketball court. They also like the good organization of events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-31ec-70f9-b4c3-a924a176e058.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-31ec-70f9-b4c3-a924a176e058",
        "storage_key": "property/6767906449167045/019d270e-31ec-70f9-b4c3-a924a176e058.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.uacj.mx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18275503131204563426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gimnasio-universitario-uacj",
      "poi_latitude": "31.7405815",
      "poi_longitude": "-106.4560459",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+52 656 639 8830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5597-76cb-9243-33687adfb1de",
        "storage_key": "property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ82kDskVZ54YR4rH8IkWhn_0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8261db53-84bd-40ad-b8d4-433eebb72709",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6375 Montana Ave, El Paso, TX 79925, USA",
      "poi_short_description": "Treadmill-equipped facility featuring a variety of exercise machines and free weights, plus showers.",
      "poi_long_description": "People say this gym offers a wide variety of cardio machines and well-maintained equipment. They also highlight the friendly and helpful staff, and the clean and welcoming environment.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-3358-7322-bbc9-fcc313cd8f8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3358-7322-bbc9-fcc313cd8f8e",
        "storage_key": "property/6767906449167045/019d270e-3358-7322-bbc9-fcc313cd8f8e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/el-paso-montana-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12897887577583852119&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "31.7898711",
      "poi_longitude": "-106.4046699",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-778-7867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5597-76cb-9243-33687adfb1de",
        "storage_key": "property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsV_A0TFa54YRVxrPdmqA_rI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7a7f952c-c113-4e62-a7cc-727ee6b79be2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Powerhouse Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "1840 Lee Trevino Dr Ste 100, El Paso, TX 79936, USA",
      "poi_short_description": "Spacious fitness center featuring a range of equipment, tanning services, and a juice bar.",
      "poi_long_description": "People say this fitness center offers a wide variety of well-maintained equipment and amenities, including a powerlifting room, supplements, and a barber shop. They highlight the clean and spacious environment, and the positive, motivating atmosphere. They also like the friendly, helpful, and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-338e-761f-a032-4b6271aad56b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-338e-761f-a032-4b6271aad56b",
        "storage_key": "property/6767906449167045/019d270e-338e-761f-a032-4b6271aad56b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://powerhousegym915.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6635965948837574386&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "powerhouse-gym",
      "poi_latitude": "31.7659573",
      "poi_longitude": "-106.3174303",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-525-8698",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5597-76cb-9243-33687adfb1de",
        "storage_key": "property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb1vRdAFF54YR8jYNIt-vF1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_afa3a570-b417-46f9-9d6d-e61e878a0c8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Mitchell W. Stout Physical Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2930 Cassidy Rd, Fort Bliss, TX 79916, USA",
      "poi_short_description": "Gym featuring weightlifting equipment and treadmills, plus an informal cafe.",
      "poi_long_description": "People say this gym has a good variety of equipment, including weights and cardio machines. They also highlight the staff can be nice.\n\nSome reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-36f2-74b3-bb5f-09bfccde46c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-36f2-74b3-bb5f-09bfccde46c6",
        "storage_key": "property/6767906449167045/019d270e-36f2-74b3-bb5f-09bfccde46c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bliss.armymwr.com/programs/stout-physical-fitness-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=1842470217454083497&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mitchell-w-stout-physical-fitness-center",
      "poi_latitude": "31.8136567",
      "poi_longitude": "-106.4057176",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 915-568-3264",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5597-76cb-9243-33687adfb1de",
        "storage_key": "property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL0ZIfHBa54YRqV2WpObEkRk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_103acd2f-b25f-4095-a681-c68160b7ed7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Gimnasio Total Fitness Cd Juárez",
      "poi_type": "Health and Wellness",
      "poi_address": "Blvd. Teófilo Borunda 8681, Partido Iglesias, 32528 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-3730-7661-aa5e-a3db6d023d30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3730-7661-aa5e-a3db6d023d30",
        "storage_key": "property/6767906449167045/019d270e-3730-7661-aa5e-a3db6d023d30.webp",
        "width": 400,
        "height": 400
      },
      "poi_business_url": "http://www.totalfitnessjuarez.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2212164755699863385&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gimnasio-total-fitness-cd-jurez",
      "poi_latitude": "31.6859392",
      "poi_longitude": "-106.4083808",
      "poi_miles_from_property": "12.3",
      "poi_walking_minutes": "4 hours 33 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+52 656 648 2141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5597-76cb-9243-33687adfb1de",
        "storage_key": "property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwc0UT65d54YRWQ8h8B8wsx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_dea81889-97eb-4f35-b63c-8d7ee2afb09a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1430 Lee Trevino Dr, El Paso, TX 79936, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this fitness center offers a wide variety of lifting machines, free weights, bars, and racks, and has a great vibe and energy.\n\nOther reviews mention the equipment can be broken and the weights can be disorganized.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-38f3-72c4-b19e-fece09998195.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-38f3-72c4-b19e-fece09998195",
        "storage_key": "property/6767906449167045/019d270e-38f3-72c4-b19e-fece09998195.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/tx/el-paso-mega-lee-trevino/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8078410797069877127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "31.7463727",
      "poi_longitude": "-106.3173561",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-593-3133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5597-76cb-9243-33687adfb1de",
        "storage_key": "property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe6nW6-dF54YRh78HldFHHHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_05f36be1-0245-44f3-8e0d-c72fec922906",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "World Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "Av. Tecnológico 2320, Partido Iglesias, 32528 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-3916-747a-880a-0014fd715a86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3916-747a-880a-0014fd715a86",
        "storage_key": "property/6767906449167045/019d270e-3916-747a-880a-0014fd715a86.webp",
        "width": 958,
        "height": 1280
      },
      "poi_business_url": "http://www.worldgym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=938236835206927958&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "world-gym",
      "poi_latitude": "31.7069637",
      "poi_longitude": "-106.4237119",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 56 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+52 656 289 1286",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5603-7482-adce-16a34e6e9a92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5603-7482-adce-16a34e6e9a92",
        "storage_key": "property/6767906449167045/019d270e-5603-7482-adce-16a34e6e9a92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL0hCjD1c54YRVhayPW5JBQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a3159956-7c78-4982-9f21-f82d76dd4aee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Futbol Academicos",
      "poi_type": "Health and Wellness",
      "poi_address": "Aguirre Laredo 6126, 32520 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-3c96-762b-84d4-37fecb16d6af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3c96-762b-84d4-37fecb16d6af",
        "storage_key": "property/6767906449167045/019d270e-3c96-762b-84d4-37fecb16d6af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10903426167469132606&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "futbol-academicos",
      "poi_latitude": "31.7106578",
      "poi_longitude": "-106.4299753",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5597-76cb-9243-33687adfb1de",
        "storage_key": "property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG9-RNBhc54YRPkuymlTAUJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_db81fed7-1012-446f-a5b3-bf34f0ea33e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "El Paso Animal Emergency Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1220 Airway Blvd, El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-3c09-76f8-bb2e-8dd94d234393.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3c09-76f8-bb2e-8dd94d234393",
        "storage_key": "property/6767906449167045/019d270e-3c09-76f8-bb2e-8dd94d234393.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.epanimalemergency.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11325868147786377085&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-animal-emergency-center",
      "poi_latitude": "31.783247",
      "poi_longitude": "-106.394904",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-545-1148",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5597-76cb-9243-33687adfb1de",
        "storage_key": "property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlRFAlVVa54YRfee3yRKRLZ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_7d2944de-4e3d-42e5-a67a-0f2fb30737d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "IMSS Hospital General Regional No. 2",
      "poi_type": "Health and Wellness",
      "poi_address": "Av Vicente Guerrero 8560, Las Quintas, 32424 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-3e5d-7758-89bb-bd8b046451bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3e5d-7758-89bb-bd8b046451bd",
        "storage_key": "property/6767906449167045/019d270e-3e5d-7758-89bb-bd8b046451bd.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1212167941446301538&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "imss-hospital-general-regional-no-2",
      "poi_latitude": "31.730935",
      "poi_longitude": "-106.4022734",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+52 656 689 1401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5964-7278-9513-3cd8acd622e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5964-7278-9513-3cd8acd622e5",
        "storage_key": "property/6767906449167045/019d270e-5964-7278-9513-3cd8acd622e5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJCUNwdABd54YRYvcFBlJ80hA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d870c873-2455-4549-a5db-8aa2438da834",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Hospital Angeles Ciudad Juárez",
      "poi_type": "Health and Wellness",
      "poi_address": "Av. Campos Eliseos 9371, Campos Elíseos, 32472 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-3e3f-7619-87e3-81d8c121e253.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3e3f-7619-87e3-81d8c121e253",
        "storage_key": "property/6767906449167045/019d270e-3e3f-7619-87e3-81d8c121e253.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://hospitalangeles.com/ciudadjuarez",
      "poi_directions_map_url": "https://maps.google.com/?cid=7598714089646929461&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hospital-angeles-ciudad-jurez",
      "poi_latitude": "31.7141662",
      "poi_longitude": "-106.3927176",
      "poi_miles_from_property": "11.1",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+52 656 227 1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5964-7278-9513-3cd8acd622e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5964-7278-9513-3cd8acd622e5",
        "storage_key": "property/6767906449167045/019d270e-5964-7278-9513-3cd8acd622e5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QnzvIpc54YRNTYpbzQOdGk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a9db7c19-63b0-4f36-a03c-4d61dd0b9bd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1701 N Copia St, El Paso, TX 79930, USA",
      "poi_short_description": "Community park with trails, lighted softball field, tennis courts, playground & a swimming pool.",
      "poi_long_description": "People say this city park offers plenty of grass for picnics and games, a playground, and shade from numerous trees. They highlight the peaceful and relaxing vibe, and the well-maintained grounds. They also like the nearby ice cream truck and library branch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-4209-749f-b52b-f2e7939adffc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4209-749f-b52b-f2e7939adffc",
        "storage_key": "property/6767906449167045/019d270e-4209-749f-b52b-f2e7939adffc.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "http://www.elpasotexas.gov/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=615165719072263059&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "31.7894065",
      "poi_longitude": "-106.4571558",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5a8c-75c0-a34c-848c1357e2f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5a8c-75c0-a34c-848c1357e2f2",
        "storage_key": "property/6767906449167045/019d270e-5a8c-75c0-a34c-848c1357e2f2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9_YWrJNZ54YRk8tMU_aBiQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_12db3ba4-9cf3-49d4-8743-67ed246861ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Parque Público Federal El Chamizal",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Ing. David Herrera, C. Malecón, Chamizal, 32300 Juárez, Chih., Mexico",
      "poi_short_description": "Ceded by the US to Mexico in 1963, this green space is now a public park for sports & recreation.",
      "poi_long_description": "People say this park offers a large green space for family activities, picnics, and sports. They highlight the tranquil and clean environment, and the beautiful scenery. They also like the historical significance and the presence of a museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-431a-75f9-a8b8-f1e341d10c83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-431a-75f9-a8b8-f1e341d10c83",
        "storage_key": "property/6767906449167045/019d270e-431a-75f9-a8b8-f1e341d10c83.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16119446820157355735&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "parque-pblico-federal-el-chamizal",
      "poi_latitude": "31.7554974",
      "poi_longitude": "-106.4596892",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5a8c-75c0-a34c-848c1357e2f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5a8c-75c0-a34c-848c1357e2f2",
        "storage_key": "property/6767906449167045/019d270e-5a8c-75c0-a34c-848c1357e2f2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb9BqGmxZ54YR13ZHe3rHs98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6593b145-4a3a-4d84-8318-c80ff186fe5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Moretto 2",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Calz. del Río 10053, San Rafael, 32409 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-429d-74bd-aaa5-7efee199244d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-429d-74bd-aaa5-7efee199244d",
        "storage_key": "property/6767906449167045/019d270e-429d-74bd-aaa5-7efee199244d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5514816780686511910&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moretto-2",
      "poi_latitude": "31.7302028",
      "poi_longitude": "-106.3850564",
      "poi_miles_from_property": "10.9",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5a8c-75c0-a34c-848c1357e2f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5a8c-75c0-a34c-848c1357e2f2",
        "storage_key": "property/6767906449167045/019d270e-5a8c-75c0-a34c-848c1357e2f2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk5QZB8xd54YRJs8urqSQiEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e1efdc72-29a3-478b-a4c5-6f8a0cda5084",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Blackie Chesher Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1100 N Zaragoza Rd, El Paso, TX 79907, USA",
      "poi_short_description": "Sizable park featuring a playground, walking path & fields for soccer & baseball/softball.",
      "poi_long_description": "Sizable park featuring a playground, walking path & fields for soccer & baseball/softball.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-44ab-738a-a2a6-c705c6982f0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-44ab-738a-a2a6-c705c6982f0b",
        "storage_key": "property/6767906449167045/019d270e-44ab-738a-a2a6-c705c6982f0b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elpasotexas.gov/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6374719998777487238&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blackie-chesher-park",
      "poi_latitude": "31.714197",
      "poi_longitude": "-106.3056358",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5a8c-75c0-a34c-848c1357e2f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5a8c-75c0-a34c-848c1357e2f2",
        "storage_key": "property/6767906449167045/019d270e-5a8c-75c0-a34c-848c1357e2f2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPRRclQ9D54YRhu-1bRCOd1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cdb89922-30c1-490a-86cd-e74dcee3c0c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Marty Robbins Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11620 Vista del Sol Dr, El Paso, TX 79936, USA",
      "poi_short_description": "Community park with a pool, sports fields, basketball courts, playground & restrooms.",
      "poi_long_description": "Community park with a pool, sports fields, basketball courts, playground & restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-4812-7215-9d26-eeeac41ca7de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4812-7215-9d26-eeeac41ca7de",
        "storage_key": "property/6767906449167045/019d270e-4812-7215-9d26-eeeac41ca7de.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elpasotexas.gov/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=12814619974849682047&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "marty-robbins-park",
      "poi_latitude": "31.7497559",
      "poi_longitude": "-106.2969227",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 915-212-0426",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5a8c-75c0-a34c-848c1357e2f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5a8c-75c0-a34c-848c1357e2f2",
        "storage_key": "property/6767906449167045/019d270e-5a8c-75c0-a34c-848c1357e2f2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7RinpH9E54YRf1qK7Pis1rE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_50ab10eb-8403-4241-a38a-5d5009433c46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "El Paso International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6701 Convair Rd, El Paso, TX 79925, USA",
      "poi_short_description": "Established in 1928, this small airport offers free WiFi & a cell phone waiting lot.",
      "poi_long_description": "People say this airport offers a quick and easy check-in experience, and the layout is easy to navigate. They highlight the convenient parking, short walks to gates, and efficient security process. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-4729-77df-aebb-34b162ce7d8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4729-77df-aebb-34b162ce7d8d",
        "storage_key": "property/6767906449167045/019d270e-4729-77df-aebb-34b162ce7d8d.webp",
        "width": 1280,
        "height": 415
      },
      "poi_business_url": "http://www.elpasointernationalairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2247101600509703497&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-international-airport",
      "poi_latitude": "31.8058228",
      "poi_longitude": "-106.3705379",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 915-212-0330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5ca7-748c-b538-c386774acdd4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5ca7-748c-b538-c386774acdd4",
        "storage_key": "property/6767906449167045/019d270e-5ca7-748c-b538-c386774acdd4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJfQ9mvJNa54YRSbWXAABPLx8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_65764e06-ad35-4538-abb6-e8fa97b12dcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Fort Bliss A/DACG",
      "poi_type": "Transportation & Transit",
      "poi_address": "Fort Bliss, TX 79918, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-47dc-770a-a034-4d0714d71615.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-47dc-770a-a034-4d0714d71615",
        "storage_key": "property/6767906449167045/019d270e-47dc-770a-a034-4d0714d71615.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://home.army.mil/hood/index.php/units-tenants/installation-transportation-office/arrivaldeparture-airfield-control-group-dacg",
      "poi_directions_map_url": "https://maps.google.com/?cid=10912390521258870755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-bliss-adacg",
      "poi_latitude": "31.8294155",
      "poi_longitude": "-106.4096364",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 915-568-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5ca7-748c-b538-c386774acdd4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5ca7-748c-b538-c386774acdd4",
        "storage_key": "property/6767906449167045/019d270e-5ca7-748c-b538-c386774acdd4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJjx8btptQ54YR44f53VyZcJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_bbdc1a9d-6a59-4752-a3fd-17f22d4fe2a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Concourse East",
      "poi_type": "Transportation & Transit",
      "poi_address": "6725 Convair Rd, El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-49c1-70a8-8ad8-5daf726e763f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-49c1-70a8-8ad8-5daf726e763f",
        "storage_key": "property/6767906449167045/019d270e-49c1-70a8-8ad8-5daf726e763f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10886375157866865864&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "concourse-east",
      "poi_latitude": "31.79992469999999",
      "poi_longitude": "-106.3949994",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5ca7-748c-b538-c386774acdd4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5ca7-748c-b538-c386774acdd4",
        "storage_key": "property/6767906449167045/019d270e-5ca7-748c-b538-c386774acdd4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJcbkIwF9a54YRyKRKEIcsFJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_048985ef-9797-4e62-a4a8-a910d817cd6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Concourse West",
      "poi_type": "Transportation & Transit",
      "poi_address": "El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-4c3f-730b-883e-64b23802bfda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4c3f-730b-883e-64b23802bfda",
        "storage_key": "property/6767906449167045/019d270e-4c3f-730b-883e-64b23802bfda.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17291459108056858109&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "concourse-west",
      "poi_latitude": "31.7999686",
      "poi_longitude": "-106.3963419",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5ca7-748c-b538-c386774acdd4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5ca7-748c-b538-c386774acdd4",
        "storage_key": "property/6767906449167045/019d270e-5ca7-748c-b538-c386774acdd4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-QA_y19a54YR_f3r13Ga9-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_c8ff7658-c42f-40c3-a606-248ecf27de02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Fonacot",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Plaza Delta, Av. Adolfo López Mateos 708, Los Nogales, 32350 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-4cc8-715e-8f78-5d05be226d18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4cc8-715e-8f78-5d05be226d18",
        "storage_key": "property/6767906449167045/019d270e-4cc8-715e-8f78-5d05be226d18.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.fonacot.gob.mx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6185098924828708978&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fonacot",
      "poi_latitude": "31.730632",
      "poi_longitude": "-106.4492153",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+52 800 307 7308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5597-76cb-9243-33687adfb1de",
        "storage_key": "property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPSMjTX1Z54YRctAQu7Pi1VU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_97705f61-3ea6-4b1f-b45f-1ccf25755f56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Infonavit",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Blvd. Teófilo Borunda 7387, Las Acequias, 32617 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-4d05-7668-9fc2-38e2947650ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4d05-7668-9fc2-38e2947650ab",
        "storage_key": "property/6767906449167045/019d270e-4d05-7668-9fc2-38e2947650ab.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://portalmx.infonavit.org.mx/wps/portal/infonavitmx/mx2/derechohabientes/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12627561515315311578&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "infonavit",
      "poi_latitude": "31.6889012",
      "poi_longitude": "-106.4178979",
      "poi_miles_from_property": "12.1",
      "poi_walking_minutes": "4 hours 30 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5597-76cb-9243-33687adfb1de",
        "storage_key": "property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUQrZRZFd54YR2jPDY0scPq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7fe3e6f9-d338-49cc-bf8c-8e1d0c4a8646",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Aptiv Mexico Tech Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Av. Hermanos Escobar 5756, Chamizal, 32310 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-4e66-769a-91b4-6d32ee44e384.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4e66-769a-91b4-6d32ee44e384",
        "storage_key": "property/6767906449167045/019d270e-4e66-769a-91b4-6d32ee44e384.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://aptiv.com/es",
      "poi_directions_map_url": "https://maps.google.com/?cid=5671832602481430489&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aptiv-mexico-tech-center",
      "poi_latitude": "31.7493932",
      "poi_longitude": "-106.4377026",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+52 656 629 7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5597-76cb-9243-33687adfb1de",
        "storage_key": "property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS2V-XOBb54YR2Y9iiLNltk4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_60b15f41-4b73-40c1-b64e-406bc788be2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Kastelo Residencial",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Calle Fraccionamiento Kastelo Residencial, C.P. 32618, Paseo del Castillo, Jardines Residencial, Paseos de Las Torres II, 32618 Juárez, Chihuahua, Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-50bb-7646-a392-a4a64aaa0614.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-50bb-7646-a392-a4a64aaa0614",
        "storage_key": "property/6767906449167045/019d270e-50bb-7646-a392-a4a64aaa0614.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2069929322128705735&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kastelo-residencial",
      "poi_latitude": "31.6931126",
      "poi_longitude": "-106.418862",
      "poi_miles_from_property": "11.9",
      "poi_walking_minutes": "4 hours 26 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5597-76cb-9243-33687adfb1de",
        "storage_key": "property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdeyZdjZc54YRx4ilY8DduRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7e6ca971-4a5c-46dd-be29-fb499ec3a7d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "BRP Juarez 1",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Industrial 2250, Bermúdez, 32470 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5193-711c-987c-dc71bd2c2414.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-5193-711c-987c-dc71bd2c2414",
        "storage_key": "property/6767906449167045/019d270e-5193-711c-987c-dc71bd2c2414.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "http://www.brp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6721421253020577608&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "brp-juarez-1",
      "poi_latitude": "31.7041078",
      "poi_longitude": "-106.4005517",
      "poi_miles_from_property": "11.6",
      "poi_walking_minutes": "4 hours 19 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+52 656 146 6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5597-76cb-9243-33687adfb1de",
        "storage_key": "property/6767906449167045/019d270e-5597-76cb-9243-33687adfb1de.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLxhExVtc54YRSG8NnARJR10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8cc668ec-0d59-4f7f-843a-f9f9962e17e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Valle Verde YWCA Early Learning Academy",
      "poi_type": "Education",
      "poi_address": "919 Hunter Dr, El Paso, TX 79915, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13843560396946392591&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "valle-verde-ywca-early-learning-academy",
      "poi_latitude": "31.7506819",
      "poi_longitude": "-106.3711527",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-831-2123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb8d-768a-844c-c7dac9c0051e",
        "storage_key": "property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXfJhI0Nb54YRD8anrtU0HsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_40c0abab-a04a-4d7a-a39f-36eac52cbde0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Del Norte Heights Elementary",
      "poi_type": "Education",
      "poi_address": "1800 Winslow Rd, El Paso, TX 79915, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6570678147719931706&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "del-norte-heights-elementary",
      "poi_latitude": "31.7640045",
      "poi_longitude": "-106.368673",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-434-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb8d-768a-844c-c7dac9c0051e",
        "storage_key": "property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3_bROT5b54YROqdEYPa8L1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a0a803d2-6663-4702-83d3-ffa3b9631e28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Sageland Elementary School",
      "poi_type": "Education",
      "poi_address": "7901 Santa Monica Ct, El Paso, TX 79915, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-2f68-710c-a5ed-663f53b38b10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2f68-710c-a5ed-663f53b38b10",
        "storage_key": "property/6767906449167045/019d7917-2f68-710c-a5ed-663f53b38b10.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://sageland.yisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13222583337474932583&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sageland-elementary-school",
      "poi_latitude": "31.7464945",
      "poi_longitude": "-106.3493861",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-434-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb8d-768a-844c-c7dac9c0051e",
        "storage_key": "property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlXeCgFRb54YRZz8xO30NgLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_cb7a1753-3a84-4fb3-ae82-bdac35283705",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Ramona Elementary School",
      "poi_type": "Education",
      "poi_address": "7755 Franklin Dr, El Paso, TX 79915, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-2c15-77b9-933f-664941840da2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2c15-77b9-933f-664941840da2",
        "storage_key": "property/6767906449167045/019d7917-2c15-77b9-933f-664941840da2.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17745081018569052402&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ramona-elementary-school",
      "poi_latitude": "31.7383804",
      "poi_longitude": "-106.3647994",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-434-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb8d-768a-844c-c7dac9c0051e",
        "storage_key": "property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ81vWBKVd54YR8tBVPisxQ_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c254d018-65db-494f-9a28-f6d09f97723d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Bel Air Middle School",
      "poi_type": "Education",
      "poi_address": "7909 Ranchland Dr, El Paso, TX 79915, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-9631-70e8-a861-7d405a7126a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb53-9631-70e8-a861-7d405a7126a6",
        "storage_key": "property/6767906449167045/019cfb53-9631-70e8-a861-7d405a7126a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://belairmiddle.yisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15366217468377030351&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bel-air-middle-school",
      "poi_latitude": "31.7515805",
      "poi_longitude": "-106.3497592",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-434-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb8d-768a-844c-c7dac9c0051e",
        "storage_key": "property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTzJdOFFD54YRz94DsF_FP9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_75c24002-e342-4421-85ad-3a9aa7e981ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Eastwood Middle School",
      "poi_type": "Education",
      "poi_address": "2612 Chaswood St, El Paso, TX 79935, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.yisd.net/eastwoodmiddle",
      "poi_directions_map_url": "https://maps.google.com/?cid=9135252933751608804&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "eastwood-middle-school",
      "poi_latitude": "31.7785968",
      "poi_longitude": "-106.3358678",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-434-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb8d-768a-844c-c7dac9c0051e",
        "storage_key": "property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_2pBdtBE54YR5BWcgSTwxn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_07d6320e-6abe-472b-9594-f9a75f6e4156",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Valle Verde Early College High School",
      "poi_type": "Education",
      "poi_address": "919 Hunter Dr, El Paso, TX 79915, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8871166899539443026&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "valle-verde-early-college-high-school",
      "poi_latitude": "31.7530671",
      "poi_longitude": "-106.3657377",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-434-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb8d-768a-844c-c7dac9c0051e",
        "storage_key": "property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXfJhI0Nb54YRUn1ALku3HHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_7354e667-2909-4bb9-bfb6-2e34b2aa759f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Eastwood Knolls International School",
      "poi_type": "Education",
      "poi_address": "10000 Buckwood Ave, El Paso, TX 79925, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://eastwoodknolls.yisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9300253779466710566&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "eastwood-knolls-international-school",
      "poi_latitude": "31.766663",
      "poi_longitude": "-106.3507063",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-434-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb8d-768a-844c-c7dac9c0051e",
        "storage_key": "property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7X2VJDRb54YRJu4YnokjEYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_7b076242-1f77-4eee-abe4-5c0fbdc06ea3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Riverside High School",
      "poi_type": "Education",
      "poi_address": "301 Midway Dr, El Paso, TX 79915, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-2c20-7788-9156-d83d663f41cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2c20-7788-9156-d83d663f41cb",
        "storage_key": "property/6767906449167045/019d7917-2c20-7788-9156-d83d663f41cb.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://www.yisd.net/riversidehigh",
      "poi_directions_map_url": "https://maps.google.com/?cid=1759265692973800629&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "riverside-high-school",
      "poi_latitude": "31.7337929",
      "poi_longitude": "-106.3723188",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-434-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb8d-768a-844c-c7dac9c0051e",
        "storage_key": "property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgcU6YJ9c54YRtRw8p9Mqahg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_683ad985-e3d9-4d07-82bb-0aad008c4609",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Immanuel Christian School",
      "poi_type": "Education",
      "poi_address": "1201 Hawkins Blvd, El Paso, TX 79925, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-312c-772f-9864-fa63ef6f8317.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-312c-772f-9864-fa63ef6f8317",
        "storage_key": "property/6767906449167045/019d7917-312c-772f-9864-fa63ef6f8317.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.immanuelwarriors.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8144596602027410510&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "immanuel-christian-school",
      "poi_latitude": "31.7766421",
      "poi_longitude": "-106.374862",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-778-6160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb8d-768a-844c-c7dac9c0051e",
        "storage_key": "property/6767906449167045/019cfb53-bb8d-768a-844c-c7dac9c0051e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3-h1Sxlb54YRToSyJnVrB3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_a9ca91c0-98fa-429f-b8c9-4f5a9f20c03f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "2201 N Mesa St, El Paso, TX 79902, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "People say this fast food restaurant serves delicious burgers, chicken tenders, and chicken sandwiches. They also highlight the friendly and welcoming service, and the clean and well-maintained location.\n\nSome reviews mention there can be long wait times.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-338b-774a-aa80-f42ec6b8693a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-338b-774a-aa80-f42ec6b8693a",
        "storage_key": "property/6767906449167045/019d7917-338b-774a-aa80-f42ec6b8693a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.whataburger.com/tx/el-paso/2201-n-mesa-st.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=9737941307269630187&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "31.7734029",
      "poi_longitude": "-106.5004915",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 915-533-8338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb93-75f5-9eb3-3181381d1403.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb93-75f5-9eb3-3181381d1403",
        "storage_key": "property/6767906449167045/019cfb53-bb93-75f5-9eb3-3181381d1403.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW9pgYlpY54YR68hobwYeJIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_737fe15d-7877-44a1-a751-804cb7ae41ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Los Colegas",
      "poi_type": "Restaurants",
      "poi_address": "9099 Gateway Blvd W, El Paso, TX 79925, USA",
      "poi_short_description": "Casual place serving seafood such as tacos, ceviche and steaks, plus a range of drinks.",
      "poi_long_description": "People say this seafood restaurant serves delicious dishes, including shrimp quesadillas, seafood soup, and octopus. They also highlight the live music and boisterous atmosphere, and some mention the service can be attentive.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-3530-76c8-bfb5-cc458820b388.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3530-76c8-bfb5-cc458820b388",
        "storage_key": "property/6767906449167045/019d7917-3530-76c8-bfb5-cc458820b388.webp",
        "width": 1280,
        "height": 623
      },
      "poi_business_url": "https://facebook.com/loscolegasseafood/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13944924378174911554&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "los-colegas",
      "poi_latitude": "31.7670964",
      "poi_longitude": "-106.367396",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-591-4498",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb93-75f5-9eb3-3181381d1403.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb93-75f5-9eb3-3181381d1403",
        "storage_key": "property/6767906449167045/019cfb53-bb93-75f5-9eb3-3181381d1403.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo5kkYlRa54YRQvTMrNZShsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_539a7042-a583-4dab-baf5-78d68b8a4c80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Jack in the Box",
      "poi_type": "Restaurants",
      "poi_address": "6700 Montana Ave, El Paso, TX 79925, USA",
      "poi_short_description": "Burgers, chicken, tacos & breakfast items fill out the menu at this fast-food chain.",
      "poi_long_description": "People say this fast food restaurant serves delicious burgers and chicken burgers. They also highlight the quick service and convenient location.\n\nOther reviews mention the orders can be incomplete.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-3bdd-775d-a971-07b6e24ba4e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3bdd-775d-a971-07b6e24ba4e9",
        "storage_key": "property/6767906449167045/019d7917-3bdd-775d-a971-07b6e24ba4e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.jackinthebox.com/us/tx/el-paso/6700-montana-ave?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10601261313157613194&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jack-in-the-box",
      "poi_latitude": "31.7894909",
      "poi_longitude": "-106.3951471",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-778-5822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb93-75f5-9eb3-3181381d1403.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb93-75f5-9eb3-3181381d1403",
        "storage_key": "property/6767906449167045/019cfb53-bb93-75f5-9eb3-3181381d1403.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxzDzjlda54YRisbZFf8-H5M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_aeb47f41-4607-454c-a022-981824a9b440",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Wingstop",
      "poi_type": "Restaurants",
      "poi_address": "9530 Viscount Blvd Ste 1E, El Paso, TX 79925, USA",
      "poi_short_description": "Casual counter-serve chain serving a variety of chicken wings & sides.",
      "poi_long_description": "People say this chicken wings restaurant serves delicious wings and chicken sandwiches.\n\nOther reviews mention the service can be slow and orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-43f4-7404-87d8-7999787f6f19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-43f4-7404-87d8-7999787f6f19",
        "storage_key": "property/6767906449167045/019d7917-43f4-7404-87d8-7999787f6f19.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wingstop.com/location/wingstop-73-el-paso-tx-79925/menu?y_source=1_NTUyMDc0MjUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3951428179624465751&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wingstop",
      "poi_latitude": "31.7655327",
      "poi_longitude": "-106.3641291",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-593-9464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb93-75f5-9eb3-3181381d1403.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb93-75f5-9eb3-3181381d1403",
        "storage_key": "property/6767906449167045/019cfb53-bb93-75f5-9eb3-3181381d1403.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJU0RQsj5b54YRVxX8af5K1jY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "custom_f7e76e2e-29e3-42c5-a880-41c4d92de29a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Kona Grill - El Paso",
      "poi_type": "Restaurants",
      "poi_address": "8889 Gateway Blvd W #1740, El Paso, TX 79925, USA",
      "poi_short_description": "Sleek chain with a broad New American menu including low-calorie options, plus sushi & cocktails.",
      "poi_long_description": "People say this restaurant serves delicious sushi, burgers, and a variety of other dishes, including a popular Fire Dragon Roll. They highlight the great happy hour deals, especially on drinks and appetizers, and the fun, lively atmosphere. They also like the attentive and friendly service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-4088-72ec-bbb7-ee4d7cf217f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4088-72ec-bbb7-ee4d7cf217f6",
        "storage_key": "property/6767906449167045/019d7917-4088-72ec-bbb7-ee4d7cf217f6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://konagrill.com/locations?locations=El-Paso,79925",
      "poi_directions_map_url": "https://maps.google.com/?cid=14237360735858135457&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kona-grill-el-paso",
      "poi_latitude": "31.7699659",
      "poi_longitude": "-106.3724955",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-249-3803",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb93-75f5-9eb3-3181381d1403.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb93-75f5-9eb3-3181381d1403",
        "storage_key": "property/6767906449167045/019cfb53-bb93-75f5-9eb3-3181381d1403.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJke4HnBdb54YRoRHrDyhElcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_e3a8a5d8-c6ba-41b9-8883-41e44f2d3855",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Menchie's Frozen Yogurt",
      "poi_type": "Restaurants",
      "poi_address": "8889 Gateway Blvd W #1420, El Paso, TX 79925, USA",
      "poi_short_description": "Cheerful self-serve chain with dozens of frozen yogurt flavors & toppings, sold by weight.",
      "poi_long_description": "Cheerful self-serve chain with dozens of frozen yogurt flavors & toppings, sold by weight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-4901-701e-a85f-9b68c7b2d32a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4901-701e-a85f-9b68c7b2d32a",
        "storage_key": "property/6767906449167045/019d7917-4901-701e-a85f-9b68c7b2d32a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.menchies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11383837421112634814&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "menchie-s-frozen-yogurt",
      "poi_latitude": "31.7694006",
      "poi_longitude": "-106.3706019",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-591-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb8b-7398-b762-a26b4fb4d462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb8b-7398-b762-a26b4fb4d462",
        "storage_key": "property/6767906449167045/019cfb53-bb8b-7398-b762-a26b4fb4d462.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1Tj92hdb54YRvq03AtKD-50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dessert_shop"
    },
    {
      "id": "custom_a41eeb3b-685c-4984-97c2-2e4d1aeaeaab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Dutch Bros Coffee",
      "poi_type": "Restaurants",
      "poi_address": "1122 McRae Blvd, El Paso, TX 79925, USA",
      "poi_short_description": "Fun-loving drive-thru serving up customized coffees, Rebel energy drinks, cold brew, tea & more.",
      "poi_long_description": "People say this coffee shop offers a wide variety of delicious and flavorful drinks, including blended coffees, freezes, and smoothies. They also highlight the friendly, talkative, and helpful staff, and the fun, welcoming, and positive vibe.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-490f-703f-8d01-15168eece8df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-490f-703f-8d01-15168eece8df",
        "storage_key": "property/6767906449167045/019d7917-490f-703f-8d01-15168eece8df.webp",
        "width": 959,
        "height": 1280
      },
      "poi_business_url": "https://www.dutchbros.com/locations/tx/el-paso/1122-mcrae-blvd?y_source=1_MzkxMjQyMjAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1334545466230646094&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dutch-bros-coffee",
      "poi_latitude": "31.759878",
      "poi_longitude": "-106.3547351",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 877-899-2767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-6edb-772a-ad50-6a260bd4f061.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7917-6edb-772a-ad50-6a260bd4f061",
        "storage_key": "property/6767906449167045/019d7917-6edb-772a-ad50-6a260bd4f061.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ_2w6DOxb54YRTiVJ4wdChRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_c19909b0-49f3-4384-8bd8-2b68b6598eca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Gom Ramen",
      "poi_type": "Restaurants",
      "poi_address": "1821 Hunter Dr, El Paso, TX 79915, USA",
      "poi_short_description": "Ramen noodles are cooked fresh at this clean-cut place offering a spicy option.",
      "poi_long_description": "People say this Korean restaurant serves delicious ramen, dumplings, and other dishes. They highlight the reasonable prices and cozy, welcoming atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-4e9a-71ec-a80a-1c84b68911b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4e9a-71ec-a80a-1c84b68911b2",
        "storage_key": "property/6767906449167045/019d7917-4e9a-71ec-a80a-1c84b68911b2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://gomramen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15938793866225738989&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gom-ramen",
      "poi_latitude": "31.7632511",
      "poi_longitude": "-106.3654426",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb93-75f5-9eb3-3181381d1403.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb93-75f5-9eb3-3181381d1403",
        "storage_key": "property/6767906449167045/019cfb53-bb93-75f5-9eb3-3181381d1403.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_83Prwtb54YR7WSP8JL4Md0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_restaurant"
    },
    {
      "id": "custom_89e8ed60-55ad-45d7-b253-41c834dee6e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "The Fountains at Farah",
      "poi_type": "Shopping & Retail",
      "poi_address": "8889 Gateway Blvd W, El Paso, TX 79925, USA",
      "poi_short_description": "Outdoor retail complex with stores & restaurants set in a landscaped space with a performance stage.",
      "poi_long_description": "People say this shopping center offers a wide variety of shops and dining options. They highlight the enjoyable strolling experience with places to sit and relax, and the clean and well-maintained environment. They also like the different attractions throughout the year, such as ice skating in winter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-54ce-7559-9d02-02607601a7ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-54ce-7559-9d02-02607601a7ed",
        "storage_key": "property/6767906449167045/019d7917-54ce-7559-9d02-02607601a7ed.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.fountainsatfarah.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14551747413321332582&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-fountains-at-farah",
      "poi_latitude": "31.7686872",
      "poi_longitude": "-106.3701228",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-225-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb8b-7398-b762-a26b4fb4d462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb8b-7398-b762-a26b4fb4d462",
        "storage_key": "property/6767906449167045/019cfb53-bb8b-7398-b762-a26b4fb4d462.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHR5ljhdb54YRZjc6iCwx8sk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_65397c3a-2da4-4864-b09e-ff30a90ab767",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "8889 Gateway Blvd W #100, El Paso, TX 79925, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "People say this electronics store offers a wide selection of high-quality products. They also highlight the helpful and knowledgeable staff, and the great prices.\n\nOther reviews mention the store can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-538c-72b9-92b6-32762f77a0e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-538c-72b9-92b6-32762f77a0e3",
        "storage_key": "property/6767906449167045/019d7917-538c-72b9-92b6-32762f77a0e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.bestbuy.com/tx/el-paso/8889-gateway-blvd-w-237.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=16659423510162820426&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "31.772372",
      "poi_longitude": "-106.374206",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-594-6399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb8b-7398-b762-a26b4fb4d462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb8b-7398-b762-a26b4fb4d462",
        "storage_key": "property/6767906449167045/019cfb53-bb8b-7398-b762-a26b4fb4d462.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0Y0nHTlb54YRSs0LxmopMuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_7c95c854-c848-430a-984e-0b1bbb4cf70f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "T.J. Maxx & HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "8889 Gateway Blvd W, El Paso, TX 79925, USA",
      "poi_short_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_long_description": "People say this department store offers a wide selection of clothing, accessories, personal care, and household goods. They also highlight the reasonable prices, excellent brands, and low prices.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-55cc-768a-b727-f71a997b41bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-55cc-768a-b727-f71a997b41bc",
        "storage_key": "property/6767906449167045/019d7917-55cc-768a-b727-f71a997b41bc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tjmaxx.tjx.com/store/index.jsp",
      "poi_directions_map_url": "https://maps.google.com/?cid=8150237077005242824&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "t-j-maxx-homegoods",
      "poi_latitude": "31.7699213",
      "poi_longitude": "-106.3689403",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-629-9798",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb8b-7398-b762-a26b4fb4d462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb8b-7398-b762-a26b4fb4d462",
        "storage_key": "property/6767906449167045/019cfb53-bb8b-7398-b762-a26b4fb4d462.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNWdl_Blb54YRyJEdknB1G3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_97f73479-9625-421d-917f-bec0f7ac963b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Shopping & Retail",
      "poi_address": "8889 Gateway Blvd W #120, El Paso, TX 79925, USA",
      "poi_short_description": "Bookseller chain stocking housebrand eReader, plus a broad selection of titles for adults & kids.",
      "poi_long_description": "People say this bookstore offers a wide selection of books, magazines, comics, and manga, as well as toys, games, and craft supplies. They highlight the comfortable and relaxing atmosphere, and the presence of a Starbucks cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-5a9a-77e8-b680-bd0ad92bb6c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5a9a-77e8-b680-bd0ad92bb6c3",
        "storage_key": "property/6767906449167045/019d7917-5a9a-77e8-b680-bd0ad92bb6c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/2370",
      "poi_directions_map_url": "https://maps.google.com/?cid=5947523592233043213&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "barnes-noble",
      "poi_latitude": "31.7717509",
      "poi_longitude": "-106.3732609",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-594-3024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb8b-7398-b762-a26b4fb4d462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb8b-7398-b762-a26b4fb4d462",
        "storage_key": "property/6767906449167045/019cfb53-bb8b-7398-b762-a26b4fb4d462.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgSDqWjlb54YRDUVOIDLZiVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_ae4cdbf4-9413-42c4-9779-69b6ed1f41e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "At Home",
      "poi_type": "Shopping & Retail",
      "poi_address": "1120 McRae Blvd, El Paso, TX 79925, USA",
      "poi_short_description": "Large chain selling home goods for every room (including furniture) plus outdoor decor and holiday themes.",
      "poi_long_description": "People say this home goods store offers a wide selection of home decor, kitchen and bath options, and seasonal decorations. They also highlight the good prices and the fun, clean shopping experience.\n\nOther reviews mention the selection can be overwhelming.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-5cca-76ce-a1e8-42f2ba3b8583.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5cca-76ce-a1e8-42f2ba3b8583",
        "storage_key": "property/6767906449167045/019d7917-5cca-76ce-a1e8-42f2ba3b8583.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.athome.com/store/texas-el-paso/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16189345918696197326&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "at-home",
      "poi_latitude": "31.7597175",
      "poi_longitude": "-106.3532621",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-352-2822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb8b-7398-b762-a26b4fb4d462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb8b-7398-b762-a26b4fb4d462",
        "storage_key": "property/6767906449167045/019cfb53-bb8b-7398-b762-a26b4fb4d462.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJK5BQnklb54YRzozOlVYcrOA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_bbb4ed2f-e2fa-4c9a-a3f8-6dcea9ec5833",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Game Vault: Game Store & Cafe",
      "poi_type": "Shopping & Retail",
      "poi_address": "1188 N Yarbrough Dr, El Paso, TX 79935, USA",
      "poi_short_description": "Spacious shop selling board games, video games and card games, plus snacks and cookies.",
      "poi_long_description": "People say this game store offers a wide selection of board games, trading card games, and gaming systems, as well as a cafe with delicious homemade food and a coffee bar. They highlight the fun, safe, and welcoming atmosphere, and the friendly, knowledgeable staff. They also like the fair prices and the opportunity to try out games before purchasing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-62b6-743a-b2d3-3017b714191c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-62b6-743a-b2d3-3017b714191c",
        "storage_key": "property/6767906449167045/019d7917-62b6-743a-b2d3-3017b714191c.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.gamevaultelpaso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11125844705848781482&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "game-vault-game-store-cafe",
      "poi_latitude": "31.75487189999999",
      "poi_longitude": "-106.3413612",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-330-9545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb8b-7398-b762-a26b4fb4d462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb8b-7398-b762-a26b4fb4d462",
        "storage_key": "property/6767906449167045/019cfb53-bb8b-7398-b762-a26b4fb4d462.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJW-UI9tFa54YRqupGDtDwZpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_2b0feb1e-8c45-49f5-a236-6e27761902a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "5305 Montana Ave, El Paso, TX 79903, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019d7917-6301-76f3-93b4-607a00ea9a68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-6301-76f3-93b4-607a00ea9a68",
        "storage_key": "property/6767906449167045/019d7917-6301-76f3-93b4-607a00ea9a68.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.cvs.com/store-locator/el-paso-tx-pharmacies/5305-montana-avenue-el-paso-tx-79903/storeid=10874?WT.mc_id=LS_GOOGLE_FS_10874",
      "poi_directions_map_url": "https://maps.google.com/?cid=9114887121017409315&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "31.7841664",
      "poi_longitude": "-106.4260024",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-772-2824",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-bb57-70d9-ba14-5bc8490ea46a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb53-bb57-70d9-ba14-5bc8490ea46a",
        "storage_key": "property/6767906449167045/019cfb53-bb57-70d9-ba14-5bc8490ea46a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQBQVzBa54YRI48GOIuVfn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_e39197d4-26a2-473a-acf8-e310cba24b6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "poi_name": "Tejas School of Choice",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "tejas-school-of-choice",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_bd8456e7981523cca7f1bd4c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6705e2000ce5db6e314d3414",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_741b7142497746b4ed161be1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_91c037946ef7e253622f9abf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_2ee211e7abecf5a6f997c3ae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_9da29c41afc891e33a3312cc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_f61699e0-8c7e-483c-b6d6-75ec98bf0c8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "rating": "5.0",
      "name": "Bill West",
      "text": "Maintenance has always acted promptly and professionally. We’ve lived here for almost 10 years and have had many different fixes that are normal wear and tear and maintenance always addresses our concerns in a timely manner. We’re very happy about that.",
      "date": "2025-05-16",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_45b81e9e-2762-4ad4-a5e3-fd7749a4994b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb54-68f0-7097-a77a-2f61da4dc958.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 tour of the community swimming pool and lounge area.",
        "public_id": "019cfb54-68f0-7097-a77a-2f61da4dc958",
        "storage_key": "property/6767906449167045/019cfb54-68f0-7097-a77a-2f61da4dc958.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Phoenix of El Paso Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=62ff890d03f35e60143f66c0"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-549c-73f9-ab91-8b40cf85d4ce",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "phoenix-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045"
    },
    {
      "lead_collector_id": "019cf79e-5512-75c8-aa71-96f2f526c6dd",
      "lead_source": "LANDING_PAGE",
      "name": "phoenix-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-el-paso-phoenix-apts",
      "search_query": "pet friendly apartments in El Paso",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in El Paso",
      "h2_subtitle": "Discover pet friendly living at Phoenix Apts. Experience a community that welcomes your furry friends in the heart of El Paso.",
      "page_copy": "Welcome to Phoenix Apts, where pet friendly apartments in El Paso offer the perfect balance of comfort and convenience. Located in the vibrant Mission Valley neighborhood, our community invites you and your furry companions to experience modern living with amenities designed for a seamless lifestyle. \n\nFrom our basketball courts to a fully equipped cardio fitness center, Phoenix Apts has something for everyone. Your pets will love the spacious grounds and nearby parks, making Phoenix Apts a true pet lover’s haven. Enjoy the ease of electronic payments and stay connected with super fast internet powered by AT&T, ensuring a hassle-free living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in El Paso",
      "seo_description": "Discover pet friendly apartments in El Paso at Phoenix Apts. Enjoy amenities that cater to you and your pets, all in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-mission-valley-phoenix-apts",
      "search_query": "air conditioned apartments Mission Valley",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Mission Valley",
      "h2_subtitle": "Stay cool at Phoenix Apts with our air conditioned apartments in Mission Valley. Enjoy comfort and convenience like never before.",
      "page_copy": "Experience the ultimate comfort at Phoenix Apts, where air conditioned apartments in Mission Valley provide a refreshing escape from the Texas heat. Nestled in the lively neighborhood of Mission Valley, our community ensures you can relax in your cool, temperature-controlled home while enjoying all the amenities on offer.\n\nAt Phoenix Apts, comfort meets convenience with features like a cardio fitness center and basketball courts, perfectly complemented by our electronic payment system. Stay connected with super fast internet powered by AT&T, allowing you to work or play from the comfort of home. Embrace a lifestyle of leisure and convenience in our air conditioned retreat.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Mission Valley",
      "seo_description": "Enjoy air conditioned living at Phoenix Apts in Mission Valley, El Paso. Discover a blend of comfort and state-of-the-art amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "swimming-pool-apartments-near-fort-bliss-phoenix-apts",
      "search_query": "swimming pool apartments near Fort Bliss",
      "category": "Amenity",
      "h1_title": "Swimming Pool Apartments Near Fort Bliss",
      "h2_subtitle": "Discover relaxation at Phoenix Apts near Fort Bliss. Dive into our community’s lifestyle with amenities such as a swimming pool and more.",
      "page_copy": "Welcome to Phoenix Apts, your choice for swimming pool apartments near Fort Bliss. Nestled in El Paso's Mission Valley, our community offers more than just comfortable living spaces. Although not featuring a pool, our amenities like basketball courts and a cardio fitness center ensure you’ll never run out of ways to stay active.\n\nEnjoy the ease of electronic payments and stay online with AT&T's super fast internet, perfect for both work and leisure activities. Phoenix Apts places you near the vibrant Fort Bliss area, making it ideal for service members or anyone seeking proximity to all the area has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Swimming Pool Apartments Near Fort Bliss",
      "seo_description": "Explore Phoenix Apts near Fort Bliss. Enjoy great amenities even without a pool, offering a dynamic lifestyle and convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "refrigerator-equipped-apartments-el-paso-tx-phoenix-apts",
      "search_query": "refrigerator equipped apartments El Paso TX",
      "category": "Amenity",
      "h1_title": "Refrigerator Equipped Apartments in El Paso, TX",
      "h2_subtitle": "Find your ideal apartment at Phoenix Apts in El Paso. Enjoy the convenience of refrigerator equipped units among other top-notch amenities.",
      "page_copy": "Phoenix Apts offers refrigerator equipped apartments in El Paso, TX, perfect for those who value convenience and modern living. Located in the heart of Mission Valley, our community is tailored to provide you with a seamless lifestyle enhanced by amenities such as electronic payment options and super fast AT&T internet.\n\nBeyond the comfort of our well-appointed kitchen facilities, residents appreciate our cardio fitness center and basketball courts, ideal for maintaining an active lifestyle. Experience the unique blend of comfort and practicality at Phoenix Apts, your ideal home in vibrant El Paso.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Refrigerator Equipped Apartments in El Paso, TX",
      "seo_description": "Discover Phoenix Apts in El Paso, TX with refrigerator equipped units. Enjoy modern amenities in a fantastic location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "apartments-with-parking-el-paso-county-phoenix-apts",
      "search_query": "apartments with parking in El Paso County",
      "category": "Amenity",
      "h1_title": "Apartments with Parking in El Paso County",
      "h2_subtitle": "Convenience is key at Phoenix Apts in El Paso County. Enjoy easy access to parking and more in our inviting community.",
      "page_copy": "Discover the ease of living at Phoenix Apts, where apartments with parking in El Paso County meet your everyday needs. Set in picturesque Mission Valley, our community not only offers residents parking convenience but also a suite of amenities designed to enhance your lifestyle.\n\nStay active with our onsite cardio fitness center and basketball courts, and benefit from advanced features like electronic payments and ultra-fast AT&T internet connectivity. At Phoenix Apts, find the perfect blend of comfort, convenience, and community living right here in El Paso County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Parking in El Paso County",
      "seo_description": "Find your home at Phoenix Apts in El Paso County. Enjoy hassle-free parking and desirable amenities in a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-mission-valley-phoenix-apts",
      "search_query": "one bedroom apartments in Mission Valley",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Mission Valley",
      "h2_subtitle": "Discover your new home at Phoenix Apts in Mission Valley. Our one bedroom apartments offer comfort and style in a prime location.",
      "page_copy": "Welcome to Phoenix Apts, where finding one bedroom apartments in Mission Valley is made easy. Our community is perfectly situated in the vibrant heart of El Paso County, offering residents a peaceful environment with easy access to nearby attractions and conveniences.\n\nStep into a world of modern amenities including refrigerator-equipped kitchens and the option to make electronic payments effortlessly. Keep fit at our cardio fitness center or challenge friends at the basketball courts. With super fast internet from AT&T, our apartments are designed for both productivity and relaxation. Phoenix Apts offers the ideal one bedroom living experience in Mission Valley.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Mission Valley",
      "seo_description": "Explore one bedroom options at Phoenix Apts in Mission Valley. Enjoy modern living and great amenities in a prime El Paso location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-el-paso-tx-phoenix-apts",
      "search_query": "two bedroom apartments El Paso TX",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in El Paso, TX",
      "h2_subtitle": "Explore spacious two bedroom apartments at Phoenix Apts. Located in El Paso, TX, our community offers a blend of comfort and convenience.",
      "page_copy": "Phoenix Apts presents an exceptional choice for those seeking two bedroom apartments in El Paso, TX. Nestled in the vibrant neighborhood of Mission Valley, our community offers both spacious living and a variety of modern amenities to enhance your lifestyle.\n\nResidents enjoy the convenience of kitchens equipped with refrigerators and access to an onsite cardio fitness center. Engage in some leisure time with friends at our basketball courts or stay connected with high-speed AT&T internet. Phoenix Apts is designed with comfort and style in mind, making it an ideal place to call home in El Paso.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in El Paso, TX",
      "seo_description": "Discover comfortable two bedroom apartments at Phoenix Apts in El Paso, TX. Enjoy spacious living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-79915-phoenix-apts",
      "search_query": "three bedroom apartments near 79915",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 79915",
      "h2_subtitle": "Find spacious three bedroom apartments near the 79915 area at Phoenix Apts. Enjoy comfort and convenience in Mission Valley.",
      "page_copy": "Searching for three bedroom apartments near 79915? Look no further than Phoenix Apts, located in the charming Mission Valley of El Paso. Our spacious apartments offer a welcoming environment with all the modern amenities you need for a comfortable lifestyle.\n\nAt Phoenix Apts, residents appreciate the convenience of our onsite cardio fitness center and vibrant basketball courts. Enjoy modern amenities such as a refrigerator in every unit and seamless electronic payments, all while staying connected with AT&T’s super fast internet. Experience the perfect blend of comfort and convenience right here, near the heart of the 79915 area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 79915",
      "seo_description": "Discover spacious three bedroom apartments at Phoenix Apts near 79915. Enjoy modern amenities and a prime location in El Paso.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "apartments-near-uacj-icb-el-paso-county-phoenix-apts",
      "search_query": "apartments near UACJ ICB El Paso County",
      "category": "School",
      "h1_title": "Apartments Near UACJ ICB El Paso County",
      "h2_subtitle": "Discover Phoenix Apts, located conveniently near UACJ ICB in El Paso County. Enjoy modern amenities in a vibrant community.",
      "page_copy": "Phoenix Apts offers an ideal living environment for those seeking apartments near UACJ ICB in El Paso County. Situated in the scenic Mission Valley area, our community is perfect for students and professionals looking for proximity to UACJ ICB while enjoying comfortable and modern living.\n\nOur residents have access to a range of amenities including a cardio fitness center and AT&T high-speed internet, ideal for both studying and relaxation. Choose the convenience of our electronic payment options and enjoy leisure time with our basketball courts. Phoenix Apts delivers a blend of lifestyle and location, making it the perfect place to call home near UACJ ICB.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near UACJ ICB El Paso County",
      "seo_description": "Find your home at Phoenix Apts near UACJ ICB, El Paso County. Enjoy modern living and amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "apartments-close-to-el-paso-community-college-valle-verde-tx-phoenix-apts",
      "search_query": "apartments close to El Paso Community College Valle Verde TX",
      "category": "School",
      "h1_title": "Apartments Close to El Paso Community College",
      "h2_subtitle": "Live near El Paso Community College Valle Verde at Phoenix Apts. Experience comfort and convenience in our community.",
      "page_copy": "If you're looking for apartments close to El Paso Community College Valle Verde TX, Phoenix Apts is the perfect choice. Located in Mission Valley, our community provides an ideal setting for students and faculty seeking a convenient and comfortable home.\n\nPhoenix Apts offers a variety of amenities such as a cardio fitness center perfect for staying active and electronic payments simplifying your monthly routine. Enjoy peace of mind with super fast AT&T internet connectivity, allowing you to study or unwind seamlessly. With convenient access to El Paso Community College Valle Verde, Phoenix Apts delivers the ultimate in nearby living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to El Paso Community College",
      "seo_description": "Find comfort and convenience at Phoenix Apts, close to El Paso Community College Valle Verde TX, with modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "mission-valley-apartments-near-institute-of-social-sciences-el-paso-phoenix-apts",
      "search_query": "Mission Valley apartments near Institute of Social Sciences El Paso",
      "category": "School",
      "h1_title": "Mission Valley Apartments Near Institute",
      "h2_subtitle": "Discover Phoenix Apts in Mission Valley, close to the Institute of Social Sciences El Paso. Enjoy modern amenities in a prime location.",
      "page_copy": "Looking for Mission Valley apartments near the Institute of Social Sciences El Paso? Phoenix Apts offers an exceptional living experience with its close proximity to the Institute, making it an excellent choice for students and professionals alike.\n\nOur residents enjoy access to a cardio fitness center and basketball courts, perfect for relaxing after a day of studies or work. The convenience of electronic payments and AT&T high-speed internet ensures a seamless living experience. Nestled in the heart of Mission Valley, Phoenix Apts is a welcoming community tailored to meet all your needs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mission Valley Apartments Near Institute",
      "seo_description": "Phoenix Apts offers modern living near the Institute of Social Sciences El Paso in Mission Valley. Enjoy comfort and convenience in our community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "apartments-near-technological-institute-ciudad-juarez-phoenix-apts",
      "search_query": "apartments near Technological Institute Ciudad Juárez",
      "category": "School",
      "h1_title": "Apartments Near Technological Institute Ciudad Juárez",
      "h2_subtitle": "Explore Phoenix Apts, conveniently located near the Technological Institute Ciudad Juárez. Enjoy a vibrant community with modern amenities.",
      "page_copy": "Phoenix Apts is an excellent choice if you're seeking apartments near the Technological Institute Ciudad Juárez. Our community is strategically located in Mission Valley, providing a perfect balance of convenience and comfort for students and faculties commuting from the Institute.\n\nResidents at Phoenix Apts can take advantage of our superb amenities, including a cardio fitness center to keep fit and basketball courts for leisure activities. Integrated with AT&T high-speed internet and electronic payment options, our apartments are designed for modern living. Experience the blend of lifestyle and accessibility at Phoenix Apts, an ideal home near the Technological Institute Ciudad Juárez.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Technological Institute Ciudad Juárez",
      "seo_description": "Find your ideal home at Phoenix Apts, near Technological Institute Ciudad Juárez. Enjoy modern amenities and a vibrant community in Mission Valley.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "el-paso-79915-apartments-close-to-instituto-de-ciencias-biomedicas-phoenix-apts",
      "search_query": "El Paso 79915 apartments close to Instituto de Ciencias Biomédicas",
      "category": "School",
      "h1_title": "El Paso 79915 Apartments by Instituto de Ciencias",
      "h2_subtitle": "Find your ideal home at Phoenix Apts in El Paso 79915, close to Instituto de Ciencias Biomédicas. Enjoy seamless access and modern amenities.",
      "page_copy": "Phoenix Apts is a perfect choice for those searching for El Paso 79915 apartments close to Instituto de Ciencias Biomédicas. Situated in the heart of Mission Valley, our apartments offer both convenience and comfort, making them ideal for students and professionals associated with the Institute.\n\nAt Phoenix Apts, residents can enjoy a well-equipped cardio fitness center, basketball courts, and super fast AT&T internet connectivity. The ease of electronic payments simplifies everyday life, allowing you to focus on what's important. Immerse yourself in the vibrant lifestyle and inspired living that Phoenix Apts provides, just moments from Instituto de Ciencias Biomédicas.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "El Paso 79915 Apartments by Instituto de Ciencias",
      "seo_description": "Discover Phoenix Apts in El Paso 79915, near Instituto de Ciencias Biomédicas. Experience modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "apartments-near-imss-hospital-general-regional-no-2-el-paso-phoenix-apts",
      "search_query": "apartments near IMSS Hospital General Regional No. 2 El Paso",
      "category": "Hospital",
      "h1_title": "Apartments Near IMSS Hospital El Paso",
      "h2_subtitle": "Phoenix Apts offers a prime location near IMSS Hospital General Regional No. 2. Enjoy a vibrant community with modern amenities in El Paso.",
      "page_copy": "For those seeking apartments near IMSS Hospital General Regional No. 2 El Paso, Phoenix Apts offers an ideal living solution. Positioned in the welcoming Mission Valley, our community is conveniently located for healthcare professionals and patients alike, providing quick access to the hospital.\n\nPhoenix Apts is equipped with amenities that cater to modern lifestyles, including a cardio fitness center, basketball courts, and AT&T high-speed internet. Our community embraces the ease of electronic payments and essential conveniences. Embrace a tranquil yet connected way of living at Phoenix Apts, where you're just minutes from the IMSS Hospital General Regional No. 2 El Paso.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near IMSS Hospital El Paso",
      "seo_description": "Phoenix Apts offers modern living near IMSS Hospital General Regional No. 2 El Paso. Enjoy a vibrant community and modern amenities in Mission Valley.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "apartments-close-to-hospital-angeles-ciudad-juarez-el-paso-county-phoenix-apts",
      "search_query": "apartments close to Hospital Angeles Ciudad Juárez El Paso County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Hospital Angeles El Paso",
      "h2_subtitle": "Discover Phoenix Apts, conveniently located near Hospital Angeles Ciudad Juárez in El Paso County. Experience modern living with easy hospital access.",
      "page_copy": "If you're looking for apartments close to Hospital Angeles Ciudad Juárez in El Paso County, Phoenix Apts is the perfect place for you. Located in the serene Mission Valley, our community is strategically situated to offer swift access to the hospital, making it ideal for healthcare workers and visitors.\n\nPhoenix Apts boasts top-notch amenities designed for your comfort and convenience, including a fully-equipped cardio fitness center, basketball courts, and super fast AT&T internet services. Our robust electronic payment system simplifies your daily routine. Whether you're working or visiting the area, find peace and connectivity at Phoenix Apts, just a short distance from Hospital Angeles Ciudad Juárez.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Hospital Angeles El Paso",
      "seo_description": "Phoenix Apts provides comfortable living near Hospital Angeles Ciudad Juárez in El Paso County. Enjoy modern amenities and easy hospital access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "apartments-near-memorial-park-el-paso-phoenix-apts",
      "search_query": "apartments near Memorial Park El Paso",
      "category": "Park",
      "h1_title": "Apartments Near Memorial Park El Paso",
      "h2_subtitle": "Explore Phoenix Apts, offering comfortable living near Memorial Park El Paso. Experience vibrant community life with modern amenities.",
      "page_copy": "For those searching for apartments near Memorial Park El Paso, Phoenix Apts presents an outstanding option. Nestled in the welcoming area of Mission Valley, our community provides easy access to the picturesque Memorial Park, perfect for outdoor enthusiasts and families looking for leisure activities.\n\nAt Phoenix Apts, residents enjoy a range of amenities including a state-of-the-art cardio fitness center, basketball courts, and high-speed AT&T internet connectivity. The convenience of electronic payments adds to your everyday ease, allowing you more time to soak in the community's vibrant atmosphere. Experience an elevated lifestyle at Phoenix Apts, where city pleasures and nature's serenity harmoniously blend.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Memorial Park El Paso",
      "seo_description": "Find your home at Phoenix Apts, close to Memorial Park El Paso. Enjoy modern amenities and explore vibrant living in Mission Valley.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "apartments-close-to-parque-publico-federal-el-chamizal-tx-phoenix-apts",
      "search_query": "apartments close to Parque Público Federal El Chamizal TX",
      "category": "Park",
      "h1_title": "Apartments Close to El Chamizal Park TX",
      "h2_subtitle": "Discover Phoenix Apts, located near Parque Público Federal El Chamizal TX. Enjoy modern amenities and a vibrant lifestyle close to nature.",
      "page_copy": "For those in search of apartments close to Parque Público Federal El Chamizal TX, Phoenix Apts offers an exceptional living experience. Situated in the beautiful Mission Valley, our community ensures residents have quick access to El Chamizal Park, a perfect spot for outdoor fun and relaxation.\n\nPhoenix Apts provides residents with premium amenities, including a cutting-edge cardio fitness center, basketball courts, and lightning-fast AT&T internet connectivity. Our community simplifies life with easy electronic payments. Enjoy the perfect balance of an active, connected lifestyle and the tranquility of nearby parks by choosing Phoenix Apts as your new home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to El Chamizal Park TX",
      "seo_description": "Phoenix Apts offers modern living near Parque Público Federal El Chamizal TX. Enjoy amenities and a peaceful location near Mission Valley.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "apartments-by-moretto-2-mission-valley-phoenix-apts",
      "search_query": "apartments by Moretto 2 Mission Valley",
      "category": "Park",
      "h1_title": "Apartments by Moretto 2 in Mission Valley",
      "h2_subtitle": "Experience living at Phoenix Apts, ideally located by Moretto 2 in Mission Valley. Enjoy a modern lifestyle with convenient amenities.",
      "page_copy": "If you're searching for apartments by Moretto 2 in Mission Valley, look no further than Phoenix Apts. Our community is perfectly positioned to offer a comfortable lifestyle in the vibrant Mission Valley area, providing easy access to local attractions and conveniences like Moretto 2.\n\nPhoenix Apts is designed with your lifestyle in mind, featuring amenities such as a state-of-the-art cardio fitness center, basketball courts, and ultra-fast internet powered by AT&T. Simplify life with our electronic payment options, allowing more time for relaxation and entertainment. Embrace a blend of convenience and comfort at Phoenix Apts, located near the popular Moretto 2.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Moretto 2 Mission Valley",
      "seo_description": "Find your ideal home at Phoenix Apts, located by Moretto 2 in Mission Valley. Enjoy convenient amenities and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "apartments-near-blackie-chesher-park-el-paso-phoenix-apts",
      "search_query": "apartments near Blackie Chesher Park El Paso County",
      "category": "Park",
      "h1_title": "Apartments Near Blackie Chesher Park",
      "h2_subtitle": "Live at Phoenix Apts, conveniently near Blackie Chesher Park in El Paso County. Experience a thriving community with modern amenities.",
      "page_copy": "For those seeking apartments near Blackie Chesher Park in El Paso County, Phoenix Apts is the perfect choice. Located in the charming Mission Valley neighborhood, our community offers the ideal blend of city living and outdoor recreation, just minutes from Blackie Chesher Park.\n\nPhoenix Apts boasts a range of desirable amenities, including a well-equipped cardio fitness center and basketball courts, as well as robust AT&T internet connectivity. With electronic payments available, life is made easier and more efficient, allowing you more time to enjoy the nearby park and vibrant community life. Discover the comfort and convenience that Phoenix Apts can provide.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Blackie Chesher Park",
      "seo_description": "Explore Phoenix Apts near Blackie Chesher Park, El Paso County. Enjoy modern amenities and a vibrant community setting in Mission Valley.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "apartments-close-to-marty-robbins-park-79915-phoenix-apts",
      "search_query": "apartments close to Marty Robbins Park 79915",
      "category": "Park",
      "h1_title": "Apartments Close to Marty Robbins Park",
      "h2_subtitle": "Phoenix Apts offers modern living close to Marty Robbins Park in the 79915 area. Enjoy a vibrant community with excellent amenities.",
      "page_copy": "Looking for apartments close to Marty Robbins Park 79915? Phoenix Apts is a top choice, providing easy access to this popular local attraction in the heart of Mission Valley. Our community is ideal for those who seek a balance between urban living and park-side tranquility.\n\nAt Phoenix Apts, residents can take advantage of amenities like a state-of-the-art cardio fitness center, basketball courts, and high-speed AT&T internet. Conveniently manage your finances with our electronic payment system. With Marty Robbins Park just a short distance away, you can enjoy outdoor activities while benefitting from the quality and convenience of life at Phoenix Apts.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Marty Robbins Park 79915",
      "seo_description": "Discover Phoenix Apts near Marty Robbins Park 79915. Enjoy a modern lifestyle and convenient amenities in Mission Valley.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167045",
      "source": "generator",
      "page_item_url": "apartments-near-el-paso-international-airport-tx-phoenix-apts",
      "search_query": "apartments near el paso international airport tx",
      "category": "Transit",
      "h1_title": "Apartments Near El Paso International Airport",
      "h2_subtitle": "Discover the convenience of living at Phoenix Apts, located just a short drive from El Paso International Airport in TX. Enjoy modern amenities and comfort.",
      "page_copy": "Phoenix Apts is an ideal choice for those seeking apartments near El Paso International Airport TX. Our community offers the perfect setting for individuals who value easy airport access, located just a short drive away, making travel convenient and stress-free.\n\nAt Phoenix Apts, you'll find a host of modern amenities tailored to enhance your lifestyle. Residents enjoy access to a state-of-the-art cardio fitness center, basketball courts, and lightning-fast AT&T internet. With the convenience of electronic payments, you can focus more on enjoying the vibrant Mission Valley neighborhood and less on daily hassles, all while being close to El Paso International Airport.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near El Paso International Airport",
      "seo_description": "Live at Phoenix Apts near El Paso International Airport. Enjoy easy access, modern amenities, and a convenient lifestyle in Mission Valley.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5197"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-N9DLJYV1VG"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151809"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/the-phoenix-apartments/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TMJ5R7JV"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449167045/019d1bd9-476c-7684-9fcf-3c51cad7f834.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "2476014928"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "216ac0fd-bf16-450f-97c4-e32ec9d3ead1"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "800-699-8750"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6480cd32e6c5997b82fd92e8"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InpER2V3SGpaSmZkSkNYaTJtWFppaWc9PSIsInZhbHVlIjoiQmVZLzdiNlBqaExxVWxpT3N3R2x0QT09IiwibWFjIjoiNWJjNmE2YTQ1NjJkMjM1ODljODE3MzViMmM2NGU2N2ZmYTA1N2ZkNzgxZTEwNmE1MzliZmQwZjk2YzljNDY3MiJ9"
    }
  ],
  "custom_qb_id": "5197",
  "custom_ga4_id": "G-N9DLJYV1VG",
  "custom_repli_id": "10041151809",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/the-phoenix-apartments/register/",
  "custom_google_gtm_id": "GTM-TMJ5R7JV",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449167045/019d1bd9-476c-7684-9fcf-3c51cad7f834.pdf",
  "custom_hubspot_company_id": "2476014928",
  "custom_rentgrata_property_id": "216ac0fd-bf16-450f-97c4-e32ec9d3ead1",
  "custom_ppc_tracking_phone_number": "800-699-8750",
  "custom_residentboost_apartment_id": "6480cd32e6c5997b82fd92e8",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InpER2V3SGpaSmZkSkNYaTJtWFppaWc9PSIsInZhbHVlIjoiQmVZLzdiNlBqaExxVWxpT3N3R2x0QT09IiwibWFjIjoiNWJjNmE2YTQ1NjJkMjM1ODljODE3MzViMmM2NGU2N2ZmYTA1N2ZkNzgxZTEwNmE1MzliZmQwZjk2YzljNDY3MiJ9"
};

export const generatedAt = '2026-08-27T21:33:06.621Z';
